/* eslint-disable react/prop-types */
/* eslint-disable camelcase */

import React, { useEffect, useState, useContext } from 'react';
import { useMediaQuery } from 'react-responsive';
import parse from 'html-react-parser';
import DateFnsUtils from '@date-io/date-fns';
import MuiAlert from '@material-ui/lab/Alert';
import { useHistory, useParams, useLocation } from 'react-router-dom';


import axios from 'axios';
import {
  Box,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  Grow,
  IconButton,
  InputAdornment,
  InputLabel,
  LinearProgress,
  makeStyles,
  MenuItem,
  Select,
  Snackbar,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
} from '@material-ui/core';
import 'date-fns';
import moment from 'moment';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import DoneIcon from '@material-ui/icons/Done';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import ClearIcon from '@material-ui/icons/Clear';
import InfoIcon from '@material-ui/icons/Info';
import SearchIcon from '@material-ui/icons/Search';
import { FaFilter } from "react-icons/fa6";
import InsertInvitationRoundedIcon from '@material-ui/icons/InsertInvitationRounded';
import { storeContext } from '../provider/Provider';
import StyledActiveChip from '../../customUI/ActiveChip';
import {
  StyledContentTableCell,
  StyledContentTableHeadCell,
  StyledContentTableHeadCell1,
  StyledContentTableHeadCell2,
  StyledTablePagination,
} from '../../customUI/table/TableStyles';

import theme from '../../theme';
import MobileTitle from '../../customUI/MobileTitle';
import { contentActions } from '../../store/content-reducer';
import useStyles from '../leads/LeadsFullView.style';
import GreenButton from '../../customUI/GreenButton';
import RedButton from '../../customUI/RedButton';
import ChipBadge from '../../customUI/ChipBadge';
import StyledSearchChip from '../../customUI/SearchChip';
import DefaultInput from '../../customUI/DefaultInput';
import MobileCard from './MobileCard';
import { authActions } from '../../store/auth-reducer';
import CustomSortIcon from '../common/CustomSortIcon';
import { trimStartString } from '../../functions';
import PurpleButton from '../../customUI/PurpleButton';
import ClientNotesDialogContent from './ClientNotesDialogContent';

function Alert(props) {
  // eslint-disable-next-line
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const { REACT_APP_FLASK_API_URL } = process.env;

const useSelectStyles = makeStyles({
  select: {
    '&:before': {
      border: null,
    },
    '&:after': {
      border: null,
    },
    '&:not(.Mui-disabled):hover::before': {
      border: null,
    },
  },
  icon: {
    fill: 'white',
  },
  root: {
    color: 'white',
  },
});

const ProdTypeList = [
  { label: 'HD', value: 'hd' },
  { label: 'AI', value: 'ai' },
  { label: 'Client', value: 'custom' },
];

const getProdTypeLabel = (value) => {
  if (!value) return '';
  const v = String(value).toLowerCase();
  if (v === 'custom') return 'Client';
  const found = ProdTypeList.find((prod) => prod.value === v);
  return found ? found.label : value;
};


const ContentFullView = () => {
  const classes = useStyles();
  const selectClasses = useSelectStyles();
  const { status } = useParams();
  const history = useHistory();
  const location = useLocation();
  const { state, dispatch } = useContext(storeContext);
  let isPhone = false;
  if (!state.websiteAnalytics.isTesting) {
    isPhone = useMediaQuery({ query: '(max-width: 768px)' });
  }
  const [stage, setStage] = useState('Topics for Review');
  const [mobileDate, setMobileDate] = useState(false);
  const [currContentStrategies, setCurrContentStrategies] = useState(null);
  const [currContentStrategy, setCurrContentStrategy] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [publishedDate, setPublishedDate] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [openStrategyDialog, setOpenStrategyDialog] = useState(false);
  const [availableYears, setAvailableYears] = useState([]);
  const [availableQuarters, setAvailableQuarters] = useState([]);
  const [currYear, setCurrYear] = useState(null);
  const [currQuarter, setCurrQuarter] = useState(null);
  const [openNotification, setOpenNotification] = useState(false);
  const [notificationAction, setNotificationAction] = useState(false);
  const [isInternalFetching, setIsInternalFetching] = useState(false);
  const [tableBodyHeight, setTableBodyHeight] = useState(0);
  const [nextPageRows, setNextPageRows] = useState(null);
  const [previousPageRows, setPreviousPageRows] = useState(null);
  const [currentPageRows, setCurrentPageRows] = useState(null);
  const [firstPageRows, setFirstPageRows] = useState(null);
  const [lastPageRows, setLastPageRows] = useState(null);
  const [disablePrevNextBtn, setDisablePrevNextBtn] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [search, setSearch] = useState('');
  const [searchChipContent, setSearchChipContent] = useState('');
  const [rejectComment, ChangeRejectComment] = useState('');
  const [rejectedCommentError, setRejectedCommentError] = useState(false);
  const [modalReviewer, setModalReviewer] = useState('');
  const [orderBy, setOrderBy] = useState('date');
  const [showDateFilter, setShowDateFilter] = useState(false);
  const [actionError, setActionError] = useState(null);
  const selectedMonth = location.state?.monthSelected;
  let fullViewTotalTemp = 0;

  useEffect(() => {
    if(!currContentStrategies)
      return;
    const allYears = currContentStrategies.map((str) => str.year)
    const currAvailableYears = allYears.filter((all, index) => allYears.indexOf(all) === (index))

    setAvailableYears(currAvailableYears);
    setTimeout(() => {
      if (currAvailableYears.length > 0)
        setCurrYear(parseInt(currAvailableYears[currAvailableYears.length-1],10));
    }, 100);
  }, [currContentStrategies]);

  useEffect(() => {
    if(!rejectComment)
      return;
    
    if(rejectComment.length >= 25)
      setRejectedCommentError(false);
    
  }, [rejectComment]);

  useEffect(() => {
    if(!currContentStrategies || !currYear)
      return;
    
    const currAvailableQuarters = currContentStrategies.filter((str) => str.year === currYear).map((qr) => qr.quarter);
    setAvailableQuarters(currAvailableQuarters);
    setCurrQuarter(parseInt(currAvailableQuarters[currAvailableQuarters.length-1], 10));
    const curr = currContentStrategies.filter((str) => str.year === currYear && str.quarter === currAvailableQuarters[0])[0].content;
    setCurrContentStrategy(curr);
  }, [currYear]);

  useEffect(() => {
    if(!availableQuarters || availableQuarters.length === 0)
      return;

    const curr = currContentStrategies.filter((str) => str.year === currYear && str.quarter === currQuarter)[0].content;
    setCurrContentStrategy(curr);
  }, [currQuarter]);

  const getPath = (statusItem = null) => {
    let currStatus = !statusItem ? state.content.fullView.currentStatus : statusItem;

    if (currStatus === 'topics_for_review') {
      currStatus = 'Topics for Review';
    } else if (currStatus === 'writing') {
      currStatus = 'Writing';
    } else if (currStatus === 'writing_external_content') {
      currStatus = 'Writing (External Content)';
    } else if (currStatus === 'needs_edits_external_content') {
      currStatus = 'Needs Edits (External Content)';
    } else if (currStatus === 'qa') {
      currStatus = 'QA';
    } else if (currStatus === 'hold') {
      currStatus = 'Hold';
    } else if (currStatus === 'content_for_review') {
      currStatus = 'Content for Review';
    } else if (currStatus === 'approved') {
      currStatus = 'Approved with Comments';
    } else if (currStatus === 'revisions') {
      currStatus = 'Revisions';
    } else if (currStatus === 'revised_content_for_review') {
      currStatus = 'Revised Content for Review';
    } else if (currStatus === 'publishing') {
      currStatus = 'Publishing';
    } else if (currStatus === 'published') {
      currStatus = 'Published';
    }  else if (currStatus === 'residual_content') {
      currStatus = 'Residual Content';
    } else if (currStatus === '') {
      currStatus = 'Published';
    }

    return currStatus
  };
  
  const handleNotificationClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenNotification(false);
  };

  const TablePaginationActions = (props) => {
    const { count, page, rowsPerPage, onPageChange } = props;
    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
      <Box sx={{ flexShrink: 0, ml: 1, mr: 1 }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          style={{ padding: '5px' }}
          aria-label="first page"
        >
          <FirstPageIcon />
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          style={{ padding: '5px' }}
          aria-label="previous page"
        >
          <KeyboardArrowLeft />
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          style={{ padding: '5px' }}
          aria-label="next page"
        >
          <KeyboardArrowRight />
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          style={{ padding: '5px' }}
          aria-label="last page"
        >
          <LastPageIcon />
        </IconButton>
      </Box>
    );
  };

  const getContentStrategy = () => {
    axios
      .get(
        `${REACT_APP_FLASK_API_URL}/dash2-proxy/client-content/strategy-notes/?client_domain=${
          state.websiteSwitch.currentWebsite
        }&ordering=year`
      )
      .then((response) => {
        setCurrContentStrategies(response.data.results);
        setIsInternalFetching(false);
      });
  }

  const updateRows = async (expression, perPage, page, searching = false) => {
    setIsInternalFetching(true);
    if (document.getElementById('tableBody')) {
      setTableBodyHeight(
        document.getElementById('tableBody').clientHeight > 300
          ? document.getElementById('tableBody').clientHeight
          : 300
      );
    }
    if (searching && search) {
      await axios
        .get(
          `${REACT_APP_FLASK_API_URL}/dash2-proxy/client-content/websites/${state.websiteSwitch.currentWebsite}/?search=${search}&${expression}&ordering=${orderBy}&page_size=${perPage}&page=${page}`
        )
        .then((res) => {
          setPreviousPageRows(res.data.results);
          setCurrentPageRows(res.data.results);
          if (page === 1) {
            setFirstPageRows(res.data.results.slice(0, perPage + 1));
          }
          dispatch({
            type: contentActions.CONTENT_SET_ALL,
            payload: {
              fullView: {
                isFetching: false,
                rows: res.data.results,
                total: res.data.count,
              },
            },
          });
          fullViewTotalTemp = res.data.count;
          axios
            .get(
              `${REACT_APP_FLASK_API_URL}/dash2-proxy/client-content/websites/${
                state.websiteSwitch.currentWebsite
              }/?search=${search}&${expression}&ordering=${orderBy}&page_size=${perPage}&page=${Math.max(1, Math.ceil(res.data.count / perPage))}`
            )
            .then((response) => {
              setLastPageRows(response.data.results);
              setIsInternalFetching(false);
            });
          setIsInternalFetching(false);
        });
    } else {
      await axios
        .get(
          `${REACT_APP_FLASK_API_URL}/dash2-proxy/client-content/websites/${state.websiteSwitch.currentWebsite}/?ordering=${orderBy}&${expression}&page_size=${perPage}&page=${page}`
          )
        .then((res) => {
          setCurrentPageRows(res.data.results);
          if (page === 1) {
            setFirstPageRows(res.data.results.slice(0, perPage + 1));
          }
          dispatch({
            type: contentActions.CONTENT_SET_ALL,
            payload: {
              fullView: {
                isFetching: false,
                rows: res.data.results,
                total: res.data.count,
              },
            },
          });
          fullViewTotalTemp = res.data.count;
          axios
            .get(
              `${REACT_APP_FLASK_API_URL}/dash2-proxy/client-content/websites/${
                state.websiteSwitch.currentWebsite
              }/?ordering=${orderBy}&${expression}&page_size=${perPage}&page=${
                Math.max(1, Math.ceil(res.data.count / perPage))
              }`
            )
            .then((response) => {
              setLastPageRows(response.data.results);
              setIsInternalFetching(false);
            });
          setIsInternalFetching(false);
        });
    }
  };

  const updateRowsPreloader = async (
    expression,
    perPage,
    page,
    usage,
    searching = false
  ) => {
    if (usage === 'previous') {
      let requestUrl = '';
      if (searching && search) {
        requestUrl = `${REACT_APP_FLASK_API_URL}/dash2-proxy/client-content/websites/${
          state.websiteSwitch.currentWebsite
        }/?search=${search}&${expression}&ordering=${orderBy}&page_size=${perPage}&page=${page - 1}`;
      } else {
        requestUrl = `${REACT_APP_FLASK_API_URL}/dash2-proxy/client-content/websites/${
          state.websiteSwitch.currentWebsite
        }/?ordering=${orderBy}&${expression}&page_size=${perPage}&page=${page - 1}`;
      }
      const res = await axios.get(requestUrl);
      if (page !== 0) {
        setDisablePrevNextBtn(false);
        setNextPageRows(currentPageRows);
        setCurrentPageRows(previousPageRows);
        setPreviousPageRows(res.data.results);
      } else {
        setDisablePrevNextBtn(false);
        setPreviousPageRows(firstPageRows);
        setCurrentPageRows(firstPageRows);
        if (state.content.fullView.total !== 0? (state.content.fullView.total / state.content.fullView.perPage > 1): (fullViewTotalTemp / state.content.fullView.perPage > 1)) {
          if (searching && search) {
            requestUrl = `${REACT_APP_FLASK_API_URL}/dash2-proxy/client-content/websites/${state.websiteSwitch.currentWebsite}/?search=${search}&${expression}&ordering=${orderBy}&page_size=${perPage}&page=${page}`;
          } else {
            requestUrl = `${REACT_APP_FLASK_API_URL}/dash2-proxy/client-content/websites/${state.websiteSwitch.currentWebsite}/?ordering=${orderBy}&${expression}&page_size=${perPage}&page=${page}`;
          }
          const req = await axios.get(requestUrl);
          setNextPageRows(req.data.results);
          setDisablePrevNextBtn(false);
        }
      }
    } else {
      let requestUrl = '';
      if (searching && search) {
        requestUrl = `${REACT_APP_FLASK_API_URL}/dash2-proxy/client-content/websites/${
          state.websiteSwitch.currentWebsite
        }/?search=${search}&${expression}&ordering=${orderBy}&page_size=${perPage}&page=${page + 1}`;
      } else {
        requestUrl = `${REACT_APP_FLASK_API_URL}/dash2-proxy/client-content/websites/${
          state.websiteSwitch.currentWebsite
        }/?ordering=${orderBy}&${expression}&page_size=${perPage}&page=${page + 1}`;
      }
      
      if (state.content.fullView.total !== 0? ((page * perPage) < state.content.fullView.total): ((page * perPage) < fullViewTotalTemp)) {
        const res = await axios.get(requestUrl);
        setDisablePrevNextBtn(false);
        setPreviousPageRows(currentPageRows);
        setCurrentPageRows(nextPageRows);
        setNextPageRows(res.data.results);
      } else if(page > 1) {
        if (searching && search) {
          requestUrl = `${REACT_APP_FLASK_API_URL}/dash2-proxy/client-content/websites/${
            state.websiteSwitch.currentWebsite
          }/?search=${search}&${expression}&ordering=${orderBy}&page_size=${perPage}&page=${page-1}`;
        } else {
          requestUrl = `${REACT_APP_FLASK_API_URL}/dash2-proxy/client-content/websites/${
            state.websiteSwitch.currentWebsite
          }/?ordering=${orderBy}&${expression}&page_size=${perPage}&page=${page-1}`;
        }
        const response = await axios.get(requestUrl);
        setPreviousPageRows(response.data.results);
        setDisablePrevNextBtn(false);
      }
    }
  };

  const handleUnSearch = (update = true) => {
    dispatch({
      type: contentActions.CONTENT_SET_ALL,
      payload: {
        fullView: {
          currentPage: 1,
        },
      },
    });
    setSearch('');
    setSearchChipContent('');
    setIsSearching(false);
    const currStatus = getPath(); 
    const expression = `platform_status=${currStatus}`;
    if(update) {
      updateRows(
        expression,
        state.content.fullView.perPage,
        1
      );
      updateRowsPreloader(
        expression,
        state.content.fullView.perPage,
        1,
        'next'
      );
    }
  };

  const setCurrStage = (statusItem = null) => {
    const currStatus = !statusItem ? state.content.fullView.currentStatus : statusItem;
    if (currStatus === 'topics_for_review') {
      setStage('Topics for Review');
    } else if (currStatus === 'writing') {
      setStage('Writing');
    } else if (currStatus === 'qa') {
      setStage('QA');
    } else if (currStatus === 'content_for_review') {
      setStage('Content for Review');
    } else if (currStatus === 'approved') {
      setStage('Approved with Comments');
    } else if (currStatus === 'revisions') {
      setStage('Revisions');
    } else if (currStatus === 'revised_content_for_review') {
      setStage('Revised Content for Review');
    } else if (currStatus === 'publishing') {
      setStage('Publishing');
    } else if (currStatus === 'published') {
      setStage('Published');
    }  else if (currStatus === 'residual_content') {
      setStage('Residual Content');
    } else if (currStatus === '') {
      setStage('Published');
    }
  };

  const handleSearch = () => {
    if (search) {
      if (search.length > 10) {
        const newSearch = `${search.slice(0, 10)}...`;
        setSearchChipContent(newSearch);
      } else {
        setSearchChipContent(search);
      }
      dispatch({
        type: contentActions.CONTENT_SET_ALL,
        payload: {
          fullView: {
            currentPage: 1,
          },
        },
      });
      const currStatus = getPath(); 
      const expression = `platform_status=${currStatus}`;
      setIsSearching(true);
      updateRows(expression, state.content.fullView.perPage, 1, true);
      updateRowsPreloader(
        expression,
        state.content.fullView.perPage,
        1,
        'next',
        true
      );
    }
  };

  const handleKeypress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  useEffect(() => {
    axios
      .get(
        `${REACT_APP_FLASK_API_URL}/dash2-proxy/client-content/websites/${state.websiteSwitch.currentWebsite}/analytics/totals/`
      )
      .then((res) => {
        dispatch({
          type: contentActions.CONTENT_SET_ALL,
          payload: {
            contentPipeline: res.data['by-status'],
            fullView: {
              availableTypes: Object.keys(
                res.data['by-type'][stage]
              ),
            },
          },
        });
      });
  }, [ stage ]);

  function getLastDayOfMonth(date) {
    const nextMonth = new Date(date);
    nextMonth.setMonth(nextMonth.getMonth() + 1);
    nextMonth.setDate(1);
    const lastDayOfMonth = new Date(nextMonth);
    lastDayOfMonth.setDate(lastDayOfMonth.getDate() - 1);
    return lastDayOfMonth.getDate();
  }

  const getPublishedDateExpression = () => {
    if (publishedDate) {
      const firstDayOfMonth = `${new Date(publishedDate).getFullYear()}-${
        (new Date(publishedDate).getMonth()+1).toLocaleString('en-US', {
          minimumIntegerDigits: 2,
          useGrouping: false,
        })
      }-01`;
      const firstDayNextMonth = `${new Date(publishedDate).getFullYear()}-${
        (new Date(publishedDate).getMonth() + 1).toLocaleString('en-US', {
          minimumIntegerDigits: 2,
          useGrouping: false,
        })
      }-${getLastDayOfMonth(new Date(publishedDate)).toLocaleString('en-US', {
          minimumIntegerDigits: 2,
          useGrouping: false,
        })}`;
      return `&published_date_range_after=${firstDayOfMonth}&published_date_range_before=${firstDayNextMonth}`;
    }

    return null;
  }

  const handleSwitchStatus = (newStatus) => {
    const currStatus = getPath(newStatus);
    setCurrStage(newStatus);
    setSearch('');
    setSearchChipContent('');
    setIsSearching(false);
    dispatch({
      type: contentActions.CONTENT_SET_ALL,
      payload: {
        fullView: {
          currentPage: 1,
        },
      },
    });
    if (isSearching) {
      handleUnSearch(false);
    }
    dispatch({
      type: contentActions.CONTENT_SET_ALL,
      payload: {
        fullView: {
          currentStatus: newStatus,
          currentType: '',
          currentPage: 1,
        },
      },
    });
    axios
      .get(
        `${REACT_APP_FLASK_API_URL}/dash2-proxy/client-content/websites/${state.websiteSwitch.currentWebsite}/analytics/totals/`
      )
      .then((res) => {
        dispatch({
          type: contentActions.CONTENT_SET_ALL,
          payload: {
            fullView: {
              availableTypes: Object.keys(res.data['by-type'][stage]),
            },
          },
        });
      });
    
    let expression = `platform_status=${currStatus}`;
    if (fromDate) {
      expression += `&date_range_after=${moment(fromDate, 'MMMM YYYY').format('YYYY-MM-01')}`;
    }
    if (toDate) {
      expression += `&date_range_before=${moment(toDate, 'MMMM YYYY').format('YYYY-MM-01')}`;
    }
    if(getPublishedDateExpression()){
      expression += getPublishedDateExpression();
    }

    updateRows(expression, state.content.fullView.perPage, 1);
    updateRowsPreloader(
      expression,
      state.content.fullView.perPage,
      1,
      'next'
    );
    history.push(`/content/full-view/${newStatus}`);
  };

  const handleFilterChange = (value, key, filterExpression = '') => {
    const fullView = {
      currentPublishedDate: '',
      currentProdType: '',
      currentType: '',
      currentPage: 1,
      currentExpression: value === 'All' ? '' : filterExpression,
    };

    fullView[key] = value;

    const currStatus = getPath(); 
      
    let expression = `platform_status=${currStatus}`;
    if (fromDate) {
      expression += `&date_range_after=${moment(fromDate, 'MMMM YYYY').format('YYYY-MM-01')}`;
    }
    if (toDate) {
      expression += `&date_range_before=${moment(toDate, 'MMMM YYYY').format('YYYY-MM-01')}`;
    }
    if(getPublishedDateExpression()){
      expression += getPublishedDateExpression();
    }
    if (state.content.fullView.currentProdType) {
      expression += `&prod_type=${encodeURIComponent(state.content.fullView.currentProdType)}`;
    }
    if(getPublishedDateExpression()){
      expression += getPublishedDateExpression();
    }
    if (value === 'All') {
      dispatch({
        type: contentActions.CONTENT_SET_ALL,
        payload: {
          fullView,
        },
      });
      updateRows(expression, state.content.fullView.perPage, 1);
      updateRowsPreloader(expression, state.content.fullView.perPage, 1, 'next', isSearching);
    } else {
      dispatch({
        type: contentActions.CONTENT_SET_ALL,
        payload: {
          fullView,
        },
      });
      expression += filterExpression;
      updateRows(expression, state.content.fullView.perPage, 1);
      updateRowsPreloader(expression, state.content.fullView.perPage, 1, 'next', isSearching);
    }
  };

  const getRequestExpression = () => {
    const currStatus = getPath();
    let expression = `platform_status=${currStatus}`;
    if (state.content.fullView.currentExpression) {
      expression += state.content.fullView.currentExpression;
    }
    if (fromDate) {
      expression += `&date_range_after=${moment(fromDate, 'MMMM YYYY').format('YYYY-MM-01')}`;
    }
    if (toDate) {
      expression += `&date_range_before=${moment(toDate, 'MMMM YYYY').format('YYYY-MM-01')}`;
    }
    if(getPublishedDateExpression()){
      expression += getPublishedDateExpression();
    }
    
    return expression;
  };

  const handlePublishDateChange = (date) => {
    if (date) {
      setPublishedDate(date);
      const firstDayOfMonth = `${date.getFullYear()}-${
        (date.getMonth()+1).toLocaleString('en-US', {
          minimumIntegerDigits: 2,
          useGrouping: false,
        })
      }-01`;
      const firstDayNextMonth = `${date.getFullYear()}-${
        (date.getMonth() + 1).toLocaleString('en-US', {
          minimumIntegerDigits: 2,
          useGrouping: false,
        })
      }-${getLastDayOfMonth(date).toLocaleString('en-US', {
          minimumIntegerDigits: 2,
          useGrouping: false,
        })}`;
      handleFilterChange(
        date,
        'currentPublishedDate',
        `&published_date_range_after=${firstDayOfMonth}&published_date_range_before=${firstDayNextMonth}`
      );
    } 
  };

  const handleFromDateChange = (date) => {
    if (date) {
      setFromDate(date);
      const currStatus = getPath(); 
      let expression = `platform_status=${currStatus}`;
      if (state.content.fullView.currentType) {
        expression += `&content_type=${encodeURIComponent(state.content.fullView.currentType)}`;
      }
      if (state.content.fullView.currentProdType) {
        expression += `&prod_type=${encodeURIComponent(state.content.fullView.currentProdType)}`;
      }
      expression += `&date_range_after=${moment(date, 'MMMM YYYY').format('YYYY-MM-01')}`;
      if (toDate) {
        expression += `&date_range_before=${moment(toDate, 'MMMM YYYY').format('YYYY-MM-01')}`;
      }
      if(getPublishedDateExpression()){
        expression += getPublishedDateExpression();
      }
      dispatch({
        type: contentActions.CONTENT_SET_ALL,
        payload: {
          fullView: {
            currentPage: 1,
          },
        },
      });
      updateRows(expression, state.content.fullView.perPage, 1);
    }
  };
  const handleToDateChange = (date) => {
    if (date) {
      setToDate(date);
      const currStatus = getPath(); 
      let expression = `platform_status=${currStatus}`;
      if (state.content.fullView.currentType) {
        expression += `&content_type=${encodeURIComponent(state.content.fullView.currentType)}`;
      }
      if (state.content.fullView.currentProdType) {
        expression += `&prod_type=${encodeURIComponent(state.content.fullView.currentProdType)}`;
      }

      if (fromDate) {
        expression += `&date_range_after=${moment(fromDate, 'MMMM YYYY').format('YYYY-MM-01')}`;
      }
      expression += `&date_range_before=${moment(date, 'MMMM YYYY').format('YYYY-MM-01')}`;
      if(getPublishedDateExpression()){
        expression += getPublishedDateExpression();
      }
      dispatch({
        type: contentActions.CONTENT_SET_ALL,
        payload: {
          fullView: {
            currentPage: 1,
          },
        },
      });
      updateRows(expression, state.content.fullView.perPage, 1);
    }
  };
  const handleDeleteDate = () => {
    setFromDate(null);
    setToDate(null);
    const currStatus = getPath(); 
    let expression = `platform_status=${currStatus}`;
    if (state.content.fullView.currentType) {
      expression += `&content_type=${encodeURIComponent(state.content.fullView.currentType)}`;
    }
    if (state.content.fullView.currentProdType) {
      expression += `&prod_type=${encodeURIComponent(state.content.fullView.currentProdType)}`;
    }
    if(getPublishedDateExpression()){
      expression += getPublishedDateExpression();
    }
    updateRows(expression, state.content.fullView.perPage, 1);
    
  };

  useEffect(() => {
    setCurrStage(status);
    dispatch({
      type: contentActions.CONTENT_SET_ALL,
      payload: {
        fullView: {
          isFetching: true,
        },
      },
    });
    if (status) {
      dispatch({
        type: contentActions.CONTENT_SET_ALL,
        payload: {
          fullView: {
            currentStatus: status,
          },
        },
      });
      state.content.fullView.currentStatus = status;
    };
    axios
      .get(
        `${REACT_APP_FLASK_API_URL}/v1/available-reviewers/${state.websiteSwitch.currentWebsite}`
      )
      .then((res) => {
        if (res.status === 200) {
          dispatch({
            type: contentActions.CONTENT_SET_ALL,
            payload: {
              contentPipeline: res.data.data.totals,
              fullView: {
                availableReviewers: [{ email: '', id: '' }].concat(res.data.data),
              },
            },
          });
        }
      });
    axios.get(`${REACT_APP_FLASK_API_URL}/get-alternative-email`).then((res) => {
      if (!res.data.error) {
        dispatch({
          type: authActions.AUTH_SET_ALL,
          payload: {
            user: {
              alternateEmail: res.data.data.alternative_email,
            },
          },
        });
      }
    });
    const currStatus = getPath(); 
    let expression = `platform_status=${currStatus}`;
    if(selectedMonth && !fromDate && !toDate) {
      const sDate = new Date(selectedMonth)
      setFromDate(sDate)
      setToDate(sDate) 
      expression += `&date_range_after=${moment(sDate, 'MMMM YYYY').format('YYYY-MM-01')}`;
      expression += `&date_range_before=${moment(sDate, 'MMMM YYYY').format('YYYY-MM-01')}`;
    }

    const callOrderly = async () => {
      await updateRows(
        expression,
        state.content.fullView.perPage,
        1
      );
      await updateRowsPreloader(
        expression,
        state.content.fullView.perPage,
        1,
        'next'
      );
    };

    callOrderly();    
    
    getContentStrategy();
  }, []);

  const handleDeletePublishedDate = () => {
    setPublishedDate(null);
    const currStatus = getPath(); 
    let expression = `platform_status=${currStatus}`;
    if (state.content.fullView.currentType) {
      expression += `&content_type=${encodeURIComponent(state.content.fullView.currentType)}`;
    }
    if (state.content.fullView.currentProdType) {
      expression += `&prod_type=${encodeURIComponent(state.content.fullView.currentProdType)}`;
    }
    if (fromDate) {
      expression += `&date_range_after=${moment(fromDate, 'MMMM YYYY').format('YYYY-MM-01')}`;
    }
    if (toDate) {
      expression += `&date_range_before=${moment(toDate, 'MMMM YYYY').format('YYYY-MM-01')}`;
    }
    updateRows(expression, state.content.fullView.perPage, 1);
  };

  const handleChangePage = (event, newPage) => {
    let rowSelection = nextPageRows;
    let usage = 'next';

    if (
      (newPage + 1) * state.content.fullView.perPage >
      state.content.fullView.total
    ) {
      rowSelection = lastPageRows;
      usage = 'previous';
    }

    if (newPage < state.content.fullView.currentPage - 1) {
      rowSelection = previousPageRows;
      usage = 'previous';
      if (newPage === 0) {
        rowSelection = firstPageRows;
        usage = 'next';
      }
    }

    dispatch({
      type: contentActions.CONTENT_SET_ALL,
      payload: {
        fullView: {
          currentPage: newPage + 1,
          rows: rowSelection,
        },
      },
    });

    axios.interceptors.request.use(
      (configs) => {
        setDisablePrevNextBtn(true);
        return configs;
      },
      (error) => Promise.reject(error)
    );

    axios.interceptors.response.use((res) => {
      setDisablePrevNextBtn(false);
      return res;
    });

    updateRowsPreloader(
      getRequestExpression(),
      state.content.fullView.perPage,
      newPage + 1,
      usage,
      isSearching
    );
  };

  const handleChangeRowsPerPage = (event) => {
    dispatch({
      type: contentActions.CONTENT_SET_ALL,
      payload: {
        fullView: {
          currentPage: 1,
          perPage: parseInt(event.target.value, 10),
        },
      },
    });
    updateRows(getRequestExpression(), parseInt(event.target.value, 10), 1, isSearching);
    updateRowsPreloader(
      getRequestExpression(),
      parseInt(event.target.value, 10),
      1,
      'next',
      isSearching
    );
  };

  const handleCheckBox = (event) => {
    setModalReviewer('');
    dispatch({
      type: contentActions.CONTENT_CHECK_BY_ID,
      payload: {
        id: event.target.name,
        checked: event.target.checked,
      },
    });
  };

  const handleCheckAll = (event) => {
    setModalReviewer('');
    dispatch({
      type: contentActions.CONTENT_CHECK_ALL,
      payload: {
        checked: event.target.checked,
      },
    });
  };

  function mapStrategyStatus(inputSubstatus) {
    const statusMap = {
      "approve": "writing",
      "reject": "rejected_topics",
    };

    return statusMap[inputSubstatus];
  }

  function mapStrategySubstatus(inputSubstatus) {
    const substatusMap = {
      "approve": "unassigned",
      "reject": null,
    };

    return substatusMap[inputSubstatus];
  }

  function mapStatus(inputSubstatus) {
    const statusMap = {
      "approve": "publishing",
      "send_for_revisions": "client_feedback",
      "approve_with_comments": "client_feedback",
      "reject": "done",
      "send_to_qa": "qa",
    };

    return statusMap[inputSubstatus];
  }

  function mapSubstatus(inputSubstatus) {
    const substatusMap = {
      "approve": "unassigned",
      "send_for_revisions": "need_revisions",
      "approve_with_comments": "approved_with_comments",
      "reject": "rejected_content",
      "send_to_qa": null,
    };

    return substatusMap[inputSubstatus] || substatusMap[inputSubstatus] === null? substatusMap[inputSubstatus]: "unassigned";
  }

  const convertToHTML = (text) => {

    if (typeof text === "undefined") 
      return text;

    const lines = text.split('\n');
    const result = lines.map((line, i) => {
      if(i === 0) {
        return line;
      }
      return `<div>${line}</div>`
    }).join('');
    return result;
  }

  function convertToObject(input) {
    const output = [];
    const notes = input.notes === undefined? 
      null:
      {
        field: "task_notes",
        note: convertToHTML(input.notes),
        content_items: [],
      };

    Object.keys(input.pages).map((key) => {
      if (Object.prototype.hasOwnProperty.call(input.pages, key)) {
        const id = key;
        const status2 = status === 'topics_for_review'? mapStrategyStatus(input.pages[key]): mapStatus(input.pages[key]);
        const substatus = status === 'topics_for_review'? mapStrategySubstatus(input.pages[key]): mapSubstatus(input.pages[key]);

        output.push(
          {
            id,
            status: status2,
            sub_status: substatus,
          }
        );
        if(notes) {
          notes.content_items.push(id);
        }
      }
      return null
    })

    return [output, notes];
  }



  const approve = async(data, approved) => {
    const [bulkData, notes] = convertToObject(data);
    await axios
      .patch(
        `${REACT_APP_FLASK_API_URL}/dash2-proxy/client-content/`,
        bulkData
      )
      .then(async (result) => {
        if(result.status === 200){
          if(notes){
            axios
            .post(
              `${REACT_APP_FLASK_API_URL}/dash2-proxy/client-content/notes/`,
              notes
            )
            .then(async (notesResult) => {
              if(notesResult.status === 200 || notesResult.status === 201) {
                updateRows(
                  getRequestExpression(),
                  state.content.fullView.perPage,
                  state.content.fullView.currentPage
                );

                await axios
                  .get(
                    `${REACT_APP_FLASK_API_URL}/dash2-proxy/client-content/websites/${state.websiteSwitch.currentWebsite}/analytics/totals/`
                  )
                  .then((res) => {
                    if (res.status === 200) {
                      if (res.data.success) {
                        dispatch({
                          type: contentActions.CONTENT_SET_ALL,
                          payload: {
                            contentPipeline: res.data['by-status'],
                          },
                        });
                      }
                    }
                });
              }
            })
          } else {
            updateRows(
              getRequestExpression(),
              state.content.fullView.perPage,
              state.content.fullView.currentPage
            );

            await axios
              .get(
                `${REACT_APP_FLASK_API_URL}/dash2-proxy/client-content/websites/${state.websiteSwitch.currentWebsite}/analytics/totals/`
              )
              .then((res) => {
                if (res.status === 200) {
                  if (res.data.success) {
                    dispatch({
                      type: contentActions.CONTENT_SET_ALL,
                      payload: {
                        contentPipeline: res.data['by-status'],
                      },
                    });
                  }
                }
            });
          }
        }
        setOpenNotification(true);
        setNotificationAction(approved);
      }).catch((e) => {
        setActionError(e.response.data.results)
      });
      setRejectedCommentError(false);
      ChangeRejectComment('');
  };

  const handleApproveSelected = (approved) => {
    const data = { pages: {} };
    
    if((!approved || (approved && state.content.fullView.selectedAction === 3)) && rejectComment.length < 25) {
      setRejectedCommentError(true);
      return;
    }

    let actionString = '';
    if(approved && state.content.fullView.selectedAction === 1) {
      actionString = 'approve';
    } else if (!approved && state.content.fullView.selectedAction === 2) {
      actionString = 'reject'
    } else if (approved && state.content.fullView.selectedAction === 3) {
      actionString = 'approve_with_comments'
    } else if (state.content.fullView.selectedAction === 4) {
      actionString = 'send_for_revisions'
    } else if (state.content.fullView.selectedAction === 5) {
      actionString = 'send_to_qa'
    }
    
    if (state.content.fullView.currentStatus === 'strategy') {
      data.notes = rejectComment;
    } else if (rejectComment) {
      data.notes = rejectComment;
    }

    Object.keys(state.content.fullView.checked).forEach((key) => {
      if (state.content.fullView.checked[key]) {
        data.pages[key] = actionString;
      }
    });
    if (state.content.fullView.currentStatus === 'topics_for_review') {
      if(rejectComment !== '' && actionString !== "approve"){
        data.notes = rejectComment
      }
    } else if (rejectComment) {
      data.notes = rejectComment;
    }
    approve(data, approved);
    setOpenDialog(false);
  };

  const handleOpenApprovalModal = (approved) => {
    let action = -1;
    if (approved === true) {
      action = 1;
    } else if (approved === 'with comments') {
      action = 3;
    } else if (approved === 'revision') {
      action = 4;
    } else if (approved === 'qa') {
      action = 5;
    } else {
      action = 2;
    }
    dispatch({
      type: contentActions.CONTENT_SET_ALL,
      payload: {
        fullView: {
          selectedAction: action,
        },
      },
    });
    setOpenDialog(true);
  };

  useEffect(() => {
    const currStatus = getPath();
    let expression = `platform_status=${currStatus}`;
    if(selectedMonth && !fromDate && !toDate) {
      const sDate = new Date(selectedMonth)
      setFromDate(sDate)
      setToDate(sDate) 
      expression += `&date_range_after=${moment(sDate, 'MMMM YYYY').format('YYYY-MM-01')}`;
      expression += `&date_range_before=${moment(sDate, 'MMMM YYYY').format('YYYY-MM-01')}`;
    }
    updateRows(
      expression,
      state.content.fullView.perPage,
      1
    );    
  }, [orderBy]);

  const handleSortClick = (value) => {
    if (orderBy === `${value}`){
      setOrderBy(`-${value}`);
      return;
    }
    
    setOrderBy(`${value}`);
  };

  const handleChangeStage = (e) => {
    setStage(e.target.value);
  };

  const handleOpenDate = () => {
    setMobileDate(true);
  };

  const handleOpenContentStrategy = () => {
    setOpenStrategyDialog(true)
  }

  const StrategyNotesDialog = () => (
    <Dialog
      open={openStrategyDialog}
      className={classes.dialogContent}
    >
      <DialogTitle id="form-dialog-title" className={classes.mainTitle}>
        <Box width='100%' marginBottom='10px'>
          {availableYears.length > 0 && <Select
            value={currYear}
          >
            {availableYears.map((el) => (
              <MenuItem
                key={el}
                value={el}
                onClick={() => setCurrYear(el)}
              >
                {el}
              </MenuItem>
            ))}
          </Select>}
        </Box>
        Behind the Strategy
      </DialogTitle>
      <DialogContent style={{
        height: '400px',
      }}>
        {availableYears.length > 0 && typeof currContentStrategy === 'string' && parse(currContentStrategy)}
        {availableYears.length === 0 && <Box textAlign='center' my={3}>
          No Content Strategies available yet for <strong style={{color: theme.palette.primary.main}}>{state.websiteSwitch.currentWebsite}</strong>
        </Box>}
      </DialogContent>
      <DialogActions>
        <Box margin='auto' display='flex' flexDirection='row' flexGap={3}>            
          <Box 
            onClick={availableQuarters && availableQuarters.filter(item => parseInt(item, 10) === 1).length > 0 ? () => setCurrQuarter(1) : null} 
            color={currQuarter === 1 ? 'white' : 'inherit' }
            borderColor={currQuarter === 1 ? theme.palette.primary.main : 'inherit' } 
            border='1px solid' 
            disabled={availableQuarters && availableQuarters.filter(item => parseInt(item, 10) === 1).length > 0}
            padding='10px' 
            cursor='pointer' 
            borderRadius='4px' 
            m={1}
            style={{
              background: currQuarter === 1 ? theme.palette.primary.main : 'inherit',
              cursor: 'pointer',
              opacity: availableQuarters && availableQuarters.filter(item => parseInt(item, 10) === 1).length > 0 ? '1' : '.3'
            }}
          >
            Q1
          </Box>
          <Box 
            onClick={availableQuarters && availableQuarters.filter(item => parseInt(item, 10) === 2).length > 0 ? () => setCurrQuarter(2) : null} 
            color={currQuarter === 2 ? 'white' : 'inherit' }
            borderColor={currQuarter === 2 ? theme.palette.primary.main : 'inherit' } 
            border='1px solid' 
            disabled={availableQuarters && availableQuarters.filter(item => parseInt(item, 10) === 2).length > 0}
            padding='10px' 
            cursor='pointer' 
            borderRadius='4px' 
            m={1}
            style={{
              background: currQuarter === 2 ? theme.palette.primary.main : 'inherit',
              cursor: 'pointer',
              opacity: availableQuarters && availableQuarters.filter(item => parseInt(item, 10) === 2).length > 0 ? '1' : '.3'
            }}
          >
            Q2
          </Box>
          <Box 
            onClick={availableQuarters && availableQuarters.filter(item => parseInt(item, 10) === 3).length > 0 ? () => setCurrQuarter(3) : null} 
            color={currQuarter === 3 ? 'white' : 'inherit' }
            borderColor={currQuarter === 3 ? theme.palette.primary.main : 'inherit' } 
            border='1px solid'
            disabled={availableQuarters && availableQuarters.filter(item => parseInt(item, 10) === 3).length > 0}
            padding='10px' 
            cursor='pointer' 
            borderRadius='4px' 
            m={1}
            style={{
              background: currQuarter === 3 ? theme.palette.primary.main : 'inherit',
              cursor: 'pointer',
              opacity: availableQuarters && availableQuarters.filter(item => parseInt(item, 10) === 3).length > 0 ? '1' : '.3'
            }}
          >
            Q3
          </Box>
          <Box 
            onClick={availableQuarters && availableQuarters.filter(item => parseInt(item, 10) === 4).length > 0 ? () => setCurrQuarter(4) : null}
            color={currQuarter === 4 ? 'white' : 'inherit' } 
            borderColor={currQuarter === 4 ? theme.palette.primary.main : 'inherit' }
            disabled={availableQuarters &&  availableQuarters.filter(item => parseInt(item, 10) === 4).length > 0}
            border='1px solid' 
            padding='10px' 
            cursor='pointer' 
            borderRadius='4px' 
            m={1}
            style={{
              background: currQuarter === 4 ? theme.palette.primary.main : 'inherit',
              cursor: 'pointer',
              opacity: availableQuarters && availableQuarters.filter(item => parseInt(item, 10) === 4).length > 0 ? '1' : '.3'
            }}
          >
            Q4
          </Box>
        </Box>
        <Button
          onClick={() => {
            setOpenStrategyDialog(false);
          }}
          style={{ 
            color: '#58595B',
            position: 'absolute',
            bottom: '15px',
            right: isPhone ? '0' : '10px',
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );

  const handleOpenSearch = () => {
    if (document.getElementById('mobileSearch').classList.contains('open')) {
      document.getElementById('mobileSearch').classList.toggle('open');
      setTimeout(() => {
        document
          .getElementById('mobileSelect')
          .parentElement.parentElement.classList.toggle('openSearch');
      }, 500);
    } else {
      document
        .getElementById('mobileSelect')
        .parentElement.parentElement.classList.toggle('openSearch');
      setTimeout(() => {
        document.getElementById('mobileSearch').classList.toggle('open');
      }, 500);
    }
  };

  const setReviewerInBulk = (user) => {
    setModalReviewer(user.email);
    const pages = [];
    Object.keys(state.content.fullView.checked).forEach((key) => {
      if (state.content.fullView.checked[key]) {
        pages.push(key.toString());
      }
    });
    const data = { user_id: user.id.toString(), pages };
    axios
      .post(`${REACT_APP_FLASK_API_URL}/v1/assign-page/${state.websiteSwitch.currentWebsite}`, data)
      .then((res) => {
        if (res.data.success) {
          setDisablePrevNextBtn(false);
          for (let i = 0; i < pages.length; i += 1) {
            dispatch({
              type: contentActions.CONTENT_SET_REVIEWER,
              payload: {
                reviewer: user,
                pageId: parseInt(pages[i], 10),
              },
            });
          }
        }
      });
  };

  const setReviewer = (user, pageId) => {
    const data = { user_id: user.id.toString(), pages: [pageId.toString()] };
    axios
      .post(`${REACT_APP_FLASK_API_URL}/v1/assign-page/${state.websiteSwitch.currentWebsite}`, data)
      .then((res) => {
        if (res.data.success) {
          setDisablePrevNextBtn(false);
          dispatch({
            type: contentActions.CONTENT_SET_REVIEWER,
            payload: {
              reviewer: user,
              pageId,
            },
          });
        }
      });
  };

  if (state.content.fullView.isFetching) {
    return (
      <LinearProgress
        style={{ width: '100%' }}
        classes={{
          colorPrimary: classes.colorPrimary,
          barColorPrimary: classes.barColorPrimary,
        }}
      />
    );
  }
  
  if (isPhone) {
    return (
      <>
        <MobileTitle title="Content">
          <Box ml='5px' mt='5px'>
            <Tooltip title="Content Strategy Notes" placement='top' style={{ fontSize: '16px'}} arrow>
              <InfoIcon style={{color: theme.palette.primary.main, cursor: 'pointer'}} onClick={handleOpenContentStrategy} />
            </Tooltip>
          </Box>
        </MobileTitle>
        <div className={classes.flex__container} id="mobileHeader">
          <TextField
            fullWidth
            className={classes.select}
            id="mobileSelect"
            defaultValue={stage}
            value={stage}
            onChange={handleChangeStage}
            variant="outlined"
            select
            SelectProps={{
              IconComponent: KeyboardArrowDownIcon,
            }}
          >
            <MenuItem key={1} value="Topics for Review" onClick={() => handleSwitchStatus('topics_for_review')}>
              Topics for Review
            </MenuItem>
            {state.content.contentCountByType.Writing !== 0 && <MenuItem key={2} value="Writing" onClick={() => handleSwitchStatus('writing')}>
              Writing
            </MenuItem>}
            {state.content.contentCountByType['Writing (External Content)'] !== 0 && <MenuItem key={2} value="Writing (External Content)" onClick={() => handleSwitchStatus('writing_external_content')}>
              Writing (External Content)
            </MenuItem>}
            {state.content.contentCountByType['Needs Edits (External Content)'] !== 0 && <MenuItem key={2} value="Needs Edits (External Content)" onClick={() => handleSwitchStatus('needs_edits_external_content')}>
              Needs Edits (External Content)
            </MenuItem>}
            {state.content.contentCountByType.QA !== 0 && <MenuItem key={3} value="QA" onClick={() => handleSwitchStatus('qa')}>
              QA
            </MenuItem>}
            <MenuItem
              key={4}
              value="Content for Review"
              onClick={() => handleSwitchStatus('content_for_review')}
            >
              Content for Review
            </MenuItem>
            {state.content.contentCountByType["Approved with Comments"] !== 0 && (
              <MenuItem
                key={7}
                value="Approved"
                onClick={() => handleSwitchStatus('approved')}
              >
                Approved
              </MenuItem>
            )}
            {state.content.contentCountByType.Hold !== 0 && (
              <MenuItem
                key={8}
                value="Hold"
                onClick={() => handleSwitchStatus('hold')}
              >
                Hold
              </MenuItem>
            )}
            {state.content.contentCountByType.Revisions !== 0 && (
              <MenuItem
                key={9}
                value="Revisions"
                onClick={() => handleSwitchStatus('revisions')}
              >
                Revisions
              </MenuItem>
            )}
            {state.content.contentCountByType["Revised Content for Review"] !== 0 && (
              <MenuItem
                key={10}
                value="Revised Content for Review"
                onClick={() => handleSwitchStatus('revised_content_for_review')}
              >
                Revised Content for Review
              </MenuItem>
            )}
            <MenuItem
              key={11}
              value="Publishing"
              onClick={() => handleSwitchStatus('publishing')}
            >
              Publishing
            </MenuItem>
            <MenuItem key={6} value="Published" onClick={() => handleSwitchStatus('published')}>
              Published
            </MenuItem>
            <MenuItem key={12} value="Residual Content" onClick={() => handleSwitchStatus('residual_content')}>
              Residual Content
            </MenuItem>
          </TextField>
          <div className={classes.searchInputFlex} id="mobileSearch">
            <TextField
              id="search-field"
              placeholder="Start Typing"
              className={classes.searchInput}
              value={search}
              aria-label="search field"
              onKeyPress={handleKeypress}
              onChange={(e) => {
                setSearch(e.target.value);
              }}
              variant="standard"
            />
            {isSearching && (
              <StyledSearchChip
                className={classes.chipMargin}
                label={`Search: ${searchChipContent}`}
                aria-label="unSearch button"
                onDelete={handleUnSearch}
                deleteIcon={<ClearIcon style={{ color: 'white' }} />}
              />
            )}
          </div>
          <p className={classes.fullViewIcons}>
            <SearchIcon onClick={handleOpenSearch} />
          </p>
          <p className={classes.fullViewIcons}>
            <InsertInvitationRoundedIcon onClick={handleOpenDate} />
          </p>
          <Dialog
            open={mobileDate}
            className={classes.datePopup}
            onClose={() => {
              setMobileDate(false);
            }}
          >
            <DialogTitle id="form-dialog-title">
              Please select the dates to filter the pages.
            </DialogTitle>
            {fromDate && !toDate && (
              <StyledActiveChip
                label={`From ${fromDate.toLocaleString('en-US', {
                  month: 'long',
                })} ${fromDate.getFullYear()}`}
                className={classes.chipMargin}
                onDelete={handleDeleteDate}
                deleteIcon={<ClearIcon style={{ color: 'white' }} />}
              />
            )}
            {!fromDate && toDate && (
              <StyledActiveChip
                label={`To ${toDate.toLocaleString('en-US', {
                  month: 'long',
                })} ${toDate.getFullYear()}`}
                className={classes.chipMargin}
                onDelete={handleDeleteDate}
                deleteIcon={<ClearIcon style={{ color: 'white' }} />}
              />
            )}
            {fromDate && toDate && (
              <StyledActiveChip
                label={`${fromDate.toLocaleString('en-US', {
                  month: 'long',
                })} ${fromDate.getFullYear()} - ${toDate.toLocaleString('en-US', {
                  month: 'long',
                })} ${toDate.getFullYear()}`}
                className={classes.chipMargin}
                onDelete={handleDeleteDate}
                deleteIcon={<ClearIcon style={{ color: 'white' }} />}
              />
            )}
            {!isSearching ? (
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DatePicker
                  variant="inline"
                  inputVariant="outlined"
                  openTo="year"
                  views={['year', 'month']}
                  label="From Date"
                  value={fromDate}
                  onChange={handleFromDateChange}
                  aria-label="from date picker"
                />
                <DatePicker
                  variant="inline"
                  inputVariant="outlined"
                  openTo="year"
                  views={['year', 'month']}
                  label="To Date"
                  value={toDate}
                  onChange={handleToDateChange}
                />
              </MuiPickersUtilsProvider>
            ) : (
              <DialogTitle id="form-dialog-title">
                You cannot select dates while searching.
              </DialogTitle>
            )}
          </Dialog>
        </div>
        {state.content.fullView.areSelected && (
          <Grow in={state.content.fullView.areSelected}>
            <div className={classes.popUpMobile}>
              <span className={classes.popUpText}>{state.content.fullView.totalChecked} items</span>
              <GreenButton
                style={{ backgroundColor: '#00B4E0' }}
                onClick={
                  state.content.fullView.checkedAll
                    ? () => handleCheckAll({ target: { checked: false } })
                    : () => handleCheckAll({ target: { checked: true } })
                }
              >
                <span style={{ fontSize: 12 }}>
                  {state.content.fullView.checkedAll ? <>Des. All</> : <>Select All</>}
                </span>
              </GreenButton>
              <GreenButton
                onClick={() => handleOpenApprovalModal(true)}
                aria-label="action-approve"
              >
                <DoneIcon className={classes.approvalText} style={{ color: 'white' }} />
              </GreenButton>
              <RedButton onClick={() => handleOpenApprovalModal(false)}>
                <ClearIcon className={classes.approvalText} style={{ color: 'white' }} />
              </RedButton>
              <ClearIcon
                style={{ color: 'white', marginLeft: 20, cursor: 'pointer' }}
                onClick={() => handleCheckAll({ target: { checked: false } })}
              />
            </div>
          </Grow>
        )}
        {state.content.fullView.total && !isInternalFetching ? (
          <div style={{ width: '100%' }}>
            {state.content.fullView.rows.map((row) => (
              <MobileCard
                key={row.id}
                row={row}
                isSelected={state.content.fullView.checked[row.id.toString()]}
              />
            ))}
          </div>
        ) : (
          <>{!isInternalFetching && <div style={{ margin: '5% 0 0 5%' }}>No results</div>}</>
        )}
        {isInternalFetching && (
          <div className={classes.loading} style={{ height: 400 }}>
            <CircularProgress />
          </div>
        )}
        {disablePrevNextBtn ? (
          <Box textAlign="center">
            <CircularProgress />
          </Box>
        ) : (
          <StyledTablePagination
            rowsPerPageOptions={[15, 50]}
            component="div"
            count={state.content.fullView.total}
            rowsPerPage={state.content.fullView.perPage}
            page={state.content.fullView.currentPage - 1}
            onPageChange={!disablePrevNextBtn && handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            nextIconButtonProps={{ 'aria-label': 'next page button' }}
            labelRowsPerPage="Rows:"
            ActionsComponent={TablePaginationActions}
          />
        )}
        <Dialog
          open={openDialog}
          onClose={() => {
            setOpenDialog(false);
          }}
          aria-labelledby="form-dialog-title"
        >
          {(state.content.fullView.selectedAction === 1 || state.content.fullView.selectedAction === 5) && (
            <>
              {state.content.fullView.currentStatus === 'topics_for_review' && (
                <DialogTitle id="form-dialog-title">
                  Are you sure you want to Approve the selected strategies?
                </DialogTitle>
              )}
              {(state.content.fullView.currentStatus === 'content_for_review' || state.content.fullView.currentStatus === 'revised_content_for_review') && (
                <DialogTitle id="form-dialog-title">
                  Are you sure you want to approve the selected article(s)?
                </DialogTitle>
              )}

              {state.content.fullView.currentStatus === 'topics_for_review' && (
                <DialogContent>
                  Approving these strategies will place them in “Writing”. Please contact your
                  account manager if you have any questions.
                </DialogContent>
              )}
              {(state.content.fullView.currentStatus === 'content_for_review' || state.content.fullView.currentStatus === 'revised_content_for_review') && (
                <DialogContent>
                  Approving these article(s) will send them to our publishing queue as they currently appear in the Google Document. If you have any comments or edits, please select &ldquo;Approve with Comments&rdquo; or &ldquo;Send for Revisions&rdquo;. Please contact your account manager if you have any questions.
                </DialogContent>
              )}
              {state.content.fullView.currentStatus === 'writing_external_content' && (
                <DialogContent>
                  Approving this action will send the articles to our quality assurance stage. Please contact your
                  account manager if you have any questions.
                </DialogContent>
              )}
              {state.content.fullView.currentStatus === 'needs_edits_external_content' && (
                <DialogContent>
                  Approving this action will send the articles to our quality assurance stage. Please contact your
                  account manager if you have any questions.
                </DialogContent>
              )}
              <DialogActions>
                <Button
                  onClick={() => {
                    setOpenDialog(false);
                  }}
                  style={{ color: '#58595B' }}
                >
                  Cancel
                </Button>
                <GreenButton aria-label="submit won" onClick={() => handleApproveSelected(true)}>
                  Submit
                </GreenButton>
              </DialogActions>
            </>
          )}
          {(state.content.fullView.selectedAction === 2 || state.content.fullView.selectedAction === 4) && (
            <>
              {state.content.fullView.currentStatus === 'topics_for_review' && (
                <DialogTitle id="form-dialog-title">
                  Are you sure you want to reject the selected article topic?
                </DialogTitle>
              )}
              {(state.content.fullView.currentStatus === 'content_for_review' || state.content.fullView.currentStatus === 'revised_content_for_review') && (
                <DialogTitle id="form-dialog-title">
                  {state.content.fullView.selectedAction === 2 ? 'Are you sure you want to reject the selected article?' : 'Are you sure you want to send the selected article(s) back for revisions?'}
                </DialogTitle>
              )}
              {state.content.fullView.currentStatus === 'topics_for_review' && (
                <DialogContent>
                  Rejecting the article topic will place it back into ideation and planning where we
                  will develop new topic(s). Please be sure to add your reasons for rejection to the
                  comments section below so we can deliver improved topics.
                </DialogContent>
              )}
              {state.content.fullView.currentStatus === 'topics_for_review' && (
                <DefaultInput
                  rows={3}
                  className={classes.rejectComment}
                  error={rejectedCommentError}
                  multiline
                  label="Please leave your note here (required)"
                  variant="outlined"
                  value={rejectComment}
                  data-testid="details_test_id"
                  type="text"
                  helperText="Please include comment longer than 25 characters"
                  onChange={(e) => {
                    ChangeRejectComment(e.target.value);
                  }}
                />
              )}
              {(state.content.fullView.currentStatus === 'content_for_review' || state.content.fullView.currentStatus === 'revised_content_for_review') && (
                <DialogContent>
                  {state.content.fullView.selectedAction === 2 ? 'Rejecting the article will place it back into “QA.” Please be sure to add your reasons/revisions to the comments section of the articles.' : 'Please include a brief note regarding your revisions. Once revisions are complete, this content will be sent back to you for review. (If you do not want to to review the content again after the revisions have been made, please select "Approve with Comments")'}
                </DialogContent>
              )}
              <DialogActions>
                <Button
                  onClick={() => {
                    setOpenDialog(false);
                  }}
                  style={{ color: '#58595B' }}
                >
                  Cancel
                </Button>
                <RedButton aria-label="submit lost" onClick={() => handleApproveSelected(false)}>
                  Submit
                </RedButton>
              </DialogActions>
            </>
          )}
        </Dialog>
        <StrategyNotesDialog />
      </>
    );
  }

  return (
    <>
      <div className={classes.wrapper}>
        <div className={classes.card}>
          <div className={classes.card__wrapper}>
            <div className={classes.card__header}>
              <Box display='flex' flexDirection='column' alignItems='flex-start' style={{ width: '100%'}}>
                <Box className={classes.heading} style={{ width: '100%'}}  display='flex' alignItems='flex-start'>
                  Content
                  <Box ml='5px' mt='5px'>
                    <Tooltip title="Content Strategy Notes" placement='top' style={{ fontSize: '16px'}} arrow>
                      <InfoIcon style={{color: theme.palette.primary.main, cursor: 'pointer'}} onClick={handleOpenContentStrategy} />
                    </Tooltip>
                  </Box>
                  <Box className={classes.searchInputFlex} ml='auto'>
                    {isSearching && (
                      <StyledSearchChip
                        className={classes.chipMargin}
                        label={`Search: ${searchChipContent}`}
                        aria-label="unSearch button"
                        onDelete={handleUnSearch}
                        deleteIcon={<ClearIcon style={{ color: 'white' }} />}
                      />
                    )}
                    <TextField
                      id="search-field"
                      placeholder="Start Typing"
                      className={classes.searchInput}
                      value={search}
                      aria-label="search field"
                      onKeyPress={handleKeypress}
                      onChange={(e) => {
                        setSearch(e.target.value);
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              style={{ padding: 3 }}
                              onClick={handleSearch}
                              aria-label="search button"
                            >
                              <SearchIcon style={{ color: 'grey' }} />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      variant="standard"
                    />
                  </Box>
                </Box>
                <Box display='flex' width="100%" flexDirection='row' justifyContent='center'>
                  {state.content.fullView.currentStatus === 'topics_for_review' ? (
                    <ChipBadge
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                      badgeContent={state.content.contentCountByType["Topics for Review"]}
                      color="secondary"
                    >
                      <StyledActiveChip
                        label="Topics for Review"
                        className={classes.chipMargin}
                        onDelete={() => handleSwitchStatus('published')}
                        deleteIcon={<DoneIcon style={{ color: 'white' }} />}
                      />
                    </ChipBadge>
                  ) : (
                    <ChipBadge
                      badgeContent={state.content.contentCountByType["Topics for Review"]}
                      color="secondary"
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                    >
                      <Chip
                        className={classes.chipMargin}
                        label="Topics for Review"
                        clickable
                        onClick={() => handleSwitchStatus('topics_for_review')}
                      />
                    </ChipBadge>
                  )}
                  {state.content.fullView.currentStatus === 'writing' ? (
                    <StyledActiveChip
                      label="Writing"
                      className={classes.chipMargin}
                      onDelete={() => handleSwitchStatus('published')}
                      deleteIcon={<DoneIcon style={{ color: 'white' }} />}
                    />
                  ) : (
                    <Chip
                      className={classes.chipMargin}
                      label="Writing"
                      clickable
                      onClick={() => handleSwitchStatus('writing')}
                      aria-label="writing chip"
                    />
                  )}
                  {state.content.contentCountByType['Writing (External Content)'] !== 0 && state.content.fullView.currentStatus === 'writing_external_content' ? (
                    <StyledActiveChip
                      label="Writing (External Content)"
                      className={classes.chipMargin}
                      onDelete={() => handleSwitchStatus('published')}
                      deleteIcon={<DoneIcon style={{ color: 'white' }} />}
                    />
                  ) : state.content.contentCountByType['Writing (External Content)'] !== 0 && (
                    <Chip
                      className={classes.chipMargin}
                      label="Writing (External Content)"
                      clickable
                      onClick={() => handleSwitchStatus('writing_external_content')}
                    />
                  )}
                  {state.content.contentCountByType['Needs Edits (External Content)'] !== 0 && state.content.fullView.currentStatus === 'needs_edits_external_content' ? (
                    <ChipBadge
                      badgeContent={state.content.contentCountByType['Needs Edits (External Content)']}
                      color="secondary"
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                    >
                      <StyledActiveChip
                        label="Needs Edits (External Content)"
                        className={classes.chipMargin}
                        onDelete={() => handleSwitchStatus('published')}
                        deleteIcon={<DoneIcon style={{ color: 'white' }} />}
                      />
                    </ChipBadge>
                  ) : state.content.contentCountByType['Needs Edits (External Content)'] !== 0 && (
                    <ChipBadge
                      badgeContent={state.content.contentCountByType['Needs Edits (External Content)']}
                      color="secondary"
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                    >
                      <Chip
                        className={classes.chipMargin}
                        label="Needs Edits (External Content)"
                        clickable
                        onClick={() => handleSwitchStatus('needs_edits_external_content')}
                      />
                    </ChipBadge>
                  )}
                  {state.content.fullView.currentStatus === 'qa' ? (
                    <StyledActiveChip
                      label="QA"
                      className={classes.chipMargin}
                      onDelete={() => handleSwitchStatus('published')}
                      deleteIcon={<DoneIcon style={{ color: 'white' }} />}
                    />
                  ) : (
                    <Chip
                      className={classes.chipMargin}
                      label="QA"
                      clickable
                      onClick={() => handleSwitchStatus('qa')}
                    />
                  )}
                  {state.content.fullView.currentStatus === 'content_for_review' ? (
                    <ChipBadge
                      badgeContent={state.content.contentCountByType["Content for Review"]}
                      color="secondary"
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                    >
                      <StyledActiveChip
                        label="Content for Review"
                        className={classes.chipMargin}
                        onDelete={() => handleSwitchStatus('published')}
                        deleteIcon={<DoneIcon style={{ color: 'white' }} />}
                      />
                    </ChipBadge>
                  ) : (
                    <ChipBadge
                      badgeContent={state.content.contentCountByType["Content for Review"]}
                      color="secondary"
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                    >
                      <Chip
                        className={classes.chipMargin}
                        label="Content for Review"
                        clickable
                        onClick={() => handleSwitchStatus('content_for_review')}
                      />
                    </ChipBadge>
                  )}
                  {state.content.contentCountByType.Revisions !== 0 && state.content.fullView.currentStatus === 'revisions' ? (
                    <StyledActiveChip
                      label="Revisions"
                      className={classes.chipMargin}
                      onDelete={() => handleSwitchStatus('topics_for_review')}
                      deleteIcon={<DoneIcon style={{ color: 'white' }} />}
                    />
                  ) : state.content.contentCountByType.Revisions !== 0 && (
                    <>
                      {state.content.contentCountByType.Revisions !== 0 && (
                        <Chip
                          className={classes.chipMargin}
                          label="Revisions"
                          clickable
                          onClick={() => handleSwitchStatus('revisions')}
                        />
                      )}
                    </>
                  )}
                  {state.content.contentCountByType["Revised Content for Review"] !== 0 && state.content.fullView.currentStatus === 'revised_content_for_review' ? (
                    <ChipBadge
                      badgeContent={state.content.contentCountByType["Revised Content for Review"]}
                      color="secondary"
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                    >
                      <StyledActiveChip
                        label="Revised Content for Review"
                        className={classes.chipMargin}
                        onDelete={() => handleSwitchStatus('topics_for_review')}
                        deleteIcon={<DoneIcon style={{ color: 'white' }} />}
                      />
                    </ChipBadge>
                  ) : state.content.contentCountByType["Revised Content for Review"] !== 0 && (
                    <>
                      {state.content.contentCountByType["Revised Content for Review"] !== 0 && (
                        <ChipBadge
                          badgeContent={state.content.contentCountByType["Revised Content for Review"]}
                          color="secondary"
                          anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                          }}
                        >
                          <Chip
                            className={classes.chipMargin}
                            label="Revised Content for Review"
                            clickable
                            onClick={() => handleSwitchStatus('revised_content_for_review')}
                          />
                        </ChipBadge>
                      )}
                    </>
                  )}
                  {state.content.fullView.currentStatus === 'approved' ? (
                    <StyledActiveChip
                      label="Approved with Comments"
                      className={classes.chipMargin}
                      onDelete={() => handleSwitchStatus('published')}
                      deleteIcon={<DoneIcon style={{ color: 'white' }} />}
                    />
                  ) : (
                    <>
                      {state.content.contentCountByType["Approved with Comments"] !== 0 && (
                        <Chip
                          className={classes.chipMargin}
                          label="Approved with Comments"
                          clickable
                          onClick={() => handleSwitchStatus('approved')}
                        />
                      )}
                    </>
                  )}
                  {state.content.fullView.currentStatus === 'publishing' ? (
                    <StyledActiveChip
                      label="Publishing"
                      className={classes.chipMargin}
                      onDelete={() => handleSwitchStatus('published')}
                      deleteIcon={<DoneIcon style={{ color: 'white' }} />}
                    />
                  ) : (
                    <Chip
                      className={classes.chipMargin}
                      label="Publishing"
                      clickable
                      onClick={() => handleSwitchStatus('publishing')}
                    />
                  )}
                  {state.content.fullView.currentStatus === 'published' ? (
                    <StyledActiveChip label="Published" className={classes.chipMargin} />
                  ) : (
                    <Chip
                      className={classes.chipMargin}
                      label="Published"
                      clickable
                      onClick={() => handleSwitchStatus('published')}
                    />
                  )}
                  {state.content.fullView.currentStatus === 'hold' ? (
                    <StyledActiveChip
                      label="Hold"
                      className={classes.chipMargin}
                      onDelete={() => handleSwitchStatus('published')}
                      deleteIcon={<DoneIcon style={{ color: 'white' }} />}
                    />
                  ) : (
                    <>
                      {state.content.contentCountByType.Hold !== 0 && (
                        <Chip
                          className={classes.chipMargin}
                          label="Hold"
                          clickable
                          onClick={() => handleSwitchStatus('hold')}
                        />
                      )}
                    </>
                  )}
                  {state.content.fullView.currentStatus === 'residual_content' ? (
                    <StyledActiveChip
                      label="Residual Content"
                      className={classes.chipMargin}
                      onDelete={() => handleSwitchStatus('residual_content')}
                      deleteIcon={<DoneIcon style={{ color: 'white' }} />}
                    />
                  ) : (
                    <>
                      {state.content.contentCountByType["Residual Content"] !== 0 && (
                        <Chip
                          className={classes.chipMargin}
                          label="Residual Content"
                          clickable
                          onClick={() => handleSwitchStatus('residual_content')}
                        />
                      )}
                    </>
                  )}
                  {fromDate && !toDate && (
                    <StyledActiveChip
                      label={`From ${fromDate.toLocaleString('en-US', {
                        month: 'long',
                      })} ${fromDate.getFullYear()}`}
                      className={classes.chipMargin}
                      onDelete={handleDeleteDate}
                      deleteIcon={<ClearIcon style={{ color: 'white' }} />}
                    />
                  )}
                  {!fromDate && toDate && (
                    <StyledActiveChip
                      label={`To ${toDate.toLocaleString('en-US', {
                        month: 'long',
                      })} ${toDate.getFullYear()}`}
                      className={classes.chipMargin}
                      onDelete={handleDeleteDate}
                      deleteIcon={<ClearIcon style={{ color: 'white' }} />}
                    />
                  )}
                  {fromDate && toDate && (
                    <StyledActiveChip
                      label={`${fromDate.toLocaleString('en-US', {
                        month: 'long',
                      })} ${fromDate.getFullYear()} - ${toDate.toLocaleString('en-US', {
                        month: 'long',
                      })} ${toDate.getFullYear()}`}
                      className={classes.chipMargin}
                      onDelete={handleDeleteDate}
                      deleteIcon={<ClearIcon style={{ color: 'white' }} />}
                    />
                  )}
                  {publishedDate && (
                    <StyledActiveChip
                      label={`${publishedDate.toLocaleString('en-US', {
                        month: 'long',
                      })} ${publishedDate.getFullYear()}`}
                      className={classes.chipMargin}
                      onDelete={handleDeletePublishedDate}
                      deleteIcon={<ClearIcon style={{ color: 'white' }} />}
                    />
                  )}
                </Box>
              </Box>
            </div>
            <Table>
              <TableHead>
                <TableRow>
                  <StyledContentTableHeadCell1>
                    {" "}
                  </StyledContentTableHeadCell1>
                  {(state.content.fullView.currentStatus === 'topics_for_review' ||
                    state.content.fullView.currentStatus === 'content_for_review' || 
                    state.content.fullView.currentStatus === 'writing_external_content' || 
                    state.content.fullView.currentStatus === 'needs_edits_external_content' ||
                    state.content.fullView.currentStatus === 'revised_content_for_review') ? (
                    <>  
                      <StyledContentTableHeadCell1 style={{ minWidth: 120 }}>
                        Select All
                        <Checkbox
                          checked={state.content.fullView.checkedAll}
                          onChange={handleCheckAll}
                          color="primary"
                          inputProps={{ 'aria-label': 'selectAll' }}
                        />
                      </StyledContentTableHeadCell1>
                      <StyledContentTableHeadCell>
                        {!isSearching ? (
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <DatePicker
                              variant="inline"
                              openTo="year"
                              views={['year', 'month']}
                              label="From"
                              value={fromDate}
                              style={{ paddingRight: 20 }}
                              onChange={handleFromDateChange}
                              aria-label="from date picker"
                            />
                            <DatePicker
                              variant="inline"
                              openTo="year"
                              views={['year', 'month']}
                              label="To"
                              value={toDate}
                              style={{ paddingRight: 20 }}
                              onChange={handleToDateChange}
                            />
                          </MuiPickersUtilsProvider>
                        ) : (
                          <>Date</>
                        )}
                      </StyledContentTableHeadCell>
                    </>
                  ) : (
                    <StyledContentTableHeadCell1>
                      <Box display='flex' style={{ cursor: 'pointer' }} flex={1} flexDirection='row' alignItems='center' justifyContent='space-between'>
                        <Box>
                          <IconButton
                            onClick={() => setShowDateFilter(!showDateFilter)}
                            style={{ padding: '5px' }}
                            aria-label="first page"
                          >
                            <FaFilter />
                          </IconButton>
                        </Box>
                        {!isSearching && showDateFilter ? (
                          <Box display='flex' flex={1} flexDirection='column' justifyContent='space-between' >
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <DatePicker
                                variant="inline"
                                openTo="year"
                                views={['year', 'month']}
                                label="From"
                                value={fromDate}
                                style={{ paddingRight: 20 }}
                                onChange={handleFromDateChange}
                              />
                              <DatePicker
                                variant="inline"
                                openTo="year"
                                views={['year', 'month']}
                                label="To"
                                value={toDate}
                                style={{ paddingRight: 20 }}
                                onChange={handleToDateChange}
                              />
                            </MuiPickersUtilsProvider>
                          </Box>
                        ) : (
                          <Box style={{ padding: "8px"}} onClick={() => handleSortClick('date')}>Date</Box>
                        )}
                        <Box onClick={() => handleSortClick('date')}>
                          <CustomSortIcon field='date' column={trimStartString(orderBy, '-')} type={orderBy === 'date'? 'asc': 'desc'} />
                        </Box>
                      </Box>
                    </StyledContentTableHeadCell1>
                  )}
                  <StyledContentTableHeadCell>
                    <Box display='flex' style={{ cursor: 'pointer' }} flex={1} justifyContent='space-between' alignItems='center' onClick={() => handleSortClick('h1')}>
                      H1
                      <Box onClick={() => handleSortClick('h1')}>
                        <CustomSortIcon field='h1' column={trimStartString(orderBy, '-')} type={orderBy === 'h1'? 'asc': 'desc'} />
                      </Box>
                    </Box>
                  </StyledContentTableHeadCell>
                  {state.content.fullView.currentStatus === 'writing_external_content' && (<StyledContentTableHeadCell>
                    <Box display='flex' style={{ cursor: 'pointer' }} flex={1} justifyContent='space-between' alignItems='center'>
                      &nbsp;
                    </Box>
                  </StyledContentTableHeadCell>)}
                  {state.content.fullView.currentStatus === 'needs_edits_external_content' && (<StyledContentTableHeadCell>
                    <Box display='flex' style={{ cursor: 'pointer' }} flex={1} justifyContent='space-between' alignItems='center'>
                      &nbsp;
                    </Box>
                  </StyledContentTableHeadCell>)}
                  <StyledContentTableHeadCell>
                    <Box display='flex' style={{ cursor: 'pointer', maxWidth: '200px' }} flex={1} justifyContent='space-between' alignItems='center' onClick={() => handleSortClick('url')}>
                      URL
                      <Box onClick={() => handleSortClick('url')}>
                        <CustomSortIcon field='url' column={trimStartString(orderBy, '-')} type={orderBy === 'url'? 'asc': 'desc'} />
                      </Box>
                    </Box>
                  </StyledContentTableHeadCell>
                  {state.content.fullView.currentStatus !== 'topics_for_review' &&
                    state.content.fullView.currentStatus !== 'writing' && state.content.fullView.currentStatus !== 'qa' && (
                      <StyledContentTableHeadCell>Google Document</StyledContentTableHeadCell>
                    )}
                  <StyledContentTableHeadCell>
                    <Box display='flex' style={{ cursor: 'pointer' }} flex={1} justifyContent='space-between' alignItems='center' onClick={() => handleSortClick('word_count')}>
                      Word Count
                      <Box onClick={() => handleSortClick('word_count')}>
                        <CustomSortIcon field='word_count' column={trimStartString(orderBy, '-')} type={orderBy === 'word_count'? 'asc': 'desc'} />
                      </Box>
                    </Box>
                  </StyledContentTableHeadCell>
                  <StyledContentTableHeadCell2>
                    {!isSearching ? (
                      <FormControl variant="outlined" style={{ minWidth: '110px' }}>
                        <InputLabel>Production</InputLabel>
                        <Select
                          value={state.content.fullView.currentProdType}
                          onChange={(event) => {
                            handleFilterChange(
                              event.target.value,
                              'currentProdType',
                              `&prod_type=${encodeURIComponent(event.target.value)}`
                            );
                          }}
                          label="Production"
                          aria-label="select production"
                        >
                          {ProdTypeList.map((prod) => (
                            <MenuItem value={prod.value} key={prod.value}>
                              {prod.label}
                            </MenuItem>
                          ))}

                        </Select>
                      </FormControl>
                    ) : (
                      <>Production</>
                    )}
                  </StyledContentTableHeadCell2>
                  <StyledContentTableHeadCell2>
                    {!isSearching ? (
                      <FormControl variant="outlined" style={{ minWidth: 100 }}>
                        <InputLabel>Type</InputLabel>
                        <Select
                          value={state.content.fullView.currentType}
                          onChange={(event) => {
                            handleFilterChange(
                              event.target.value,
                              'currentType',
                              `&content_type=${encodeURIComponent(event.target.value)}`
                            );
                          }}
                          label="Type"
                          aria-label="select type"
                        >
                          {state.content.fullView.availableTypes.map((type) => (
                            <MenuItem value={type} key={type}>
                              {type}
                            </MenuItem>
                          ))}
                          <MenuItem value="All" aria-label="select type all">
                            All
                          </MenuItem>
                        </Select>
                      </FormControl>
                    ) : (
                      <>Type</>
                    )}
                  </StyledContentTableHeadCell2>
                  {(state.content.fullView.currentStatus === 'content_for_review' ||
                    state.content.fullView.currentStatus === 'revised_content_for_review') &&
                    state.websiteSwitch.currentWebsiteSettings.assignPageFeature && (
                      <StyledContentTableHeadCell2 style={{ minWidth: 200 }}>
                        Reviewer
                      </StyledContentTableHeadCell2>
                    )}
                  {state.content.fullView.currentStatus === 'published' && (
                    <StyledContentTableHeadCell>
                      {!isSearching ? (
                        <FormControl variant="outlined" style={{ minWidth: 150, cursor: 'pointer !important' }}>
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <DatePicker
                              openTo="year"
                              views={['year', 'month']}
                              label="Published Date"
                              value={publishedDate}
                              style={{ paddingRight: 20, cursor: 'pointer !important' }}
                              onChange={handlePublishDateChange}
                              aria-label="from date picker"
                            />
                          </MuiPickersUtilsProvider>
                        </FormControl>
                      ) : (
                        <>Published Date</>
                      )}
                    </StyledContentTableHeadCell>
                  )}
                </TableRow>
              </TableHead>
              {!isInternalFetching && (
                <TableBody id="tableBody">
                  {state.content.fullView.total ? (
                    state.content.fullView.rows?.map((row, index) =>
                      state.content.fullView.checked[row.id.toString()] === true ? (
                        <TableRow key={row.id}>
                          <StyledContentTableCell
                            component="th"
                            scope="row"
                            style={{ backgroundColor: '#f2f9ff' }}
                          >
                            {(index + 1) + (state.content.fullView.perPage * (state.content.fullView.currentPage - 1))}
                          </StyledContentTableCell>
                          {(state.content.fullView.currentStatus === 'topics_for_review' ||
                            state.content.fullView.currentStatus === 'writing_external_content' ||
                            state.content.fullView.currentStatus === 'needs_edits_external_content' ||
                            state.content.fullView.currentStatus === 'content_for_review' || 
                            state.content.fullView.currentStatus === 'revised_content_for_review'
                          ) && (
                            <>
                              <StyledContentTableCell
                                component="th"
                                scope="row"
                                style={{ backgroundColor: '#f2f9ff' }}
                              >
                                <Checkbox
                                  checked={state.content.fullView.checked[row.id.toString()]}
                                  onChange={handleCheckBox}
                                  name={row.id.toString()}
                                  color="primary"
                                  inputProps={{ 'aria-label': 'checkbox' }}
                                />
                              </StyledContentTableCell>
                            </>
                          )}
                          <StyledContentTableCell
                            component="th"
                            scope="row"
                            style={{ backgroundColor: '#f2f9ff' }}
                          >
                            {row.date}
                          </StyledContentTableCell>
                          <StyledContentTableCell
                            component="th"
                            scope="row"
                            style={{ backgroundColor: '#f2f9ff' }}
                          >
                            {row.h1}
                          </StyledContentTableCell>

                          {state.content.fullView.currentStatus === 'writing_external_content' && (<StyledContentTableCell
                            component="th"
                            scope="row"
                            style={{ backgroundColor: '#f2f9ff' }}
                          >
                            <Box ml='5px' mt='5px'>
                                <Tooltip title={row.client_notes? "See Notes": "No notes available!"} placement='top' style={{ fontSize: '16px'}} arrow>
                                  <InfoIcon 
                                      onClick={() => { 
                                        if(row.client_notes){
                                          dispatch({
                                            type: contentActions.SET_CLIENT_NOTES_OPEN,
                                            payload: { 
                                              clientNotesOpen: true,
                                            }
                                          })
                                          dispatch({
                                              type: contentActions.SET_SELECTED_CLIENT_NOTE,
                                              payload: { 
                                                selectedClientNote: row.client_notes || "No notes available!",
                                              }
                                          }) 
                                        }
                                      }} 
                                      style={{color: row.client_notes? theme.palette.primary.main: "#D5D5D5", cursor: 'pointer'}} />
                                </Tooltip>
                            </Box>
                          </StyledContentTableCell>)}
                          {state.content.fullView.currentStatus === 'needs_edits_external_content' && (<StyledContentTableCell
                            component="th"
                            scope="row"
                            style={{ backgroundColor: '#f2f9ff' }}
                          >
                            <Box ml='5px' mt='5px'>
                                <Tooltip title={row.client_notes? "See Notes": "No notes available!"} placement='top' style={{ fontSize: '16px'}} arrow>
                                  <InfoIcon 
                                      onClick={() => { 
                                        if(row.client_notes){
                                          dispatch({
                                            type: contentActions.SET_CLIENT_NOTES_OPEN,
                                            payload: { 
                                              clientNotesOpen: true,
                                            }
                                          })
                                          dispatch({
                                              type: contentActions.SET_SELECTED_CLIENT_NOTE,
                                              payload: { 
                                                selectedClientNote: row.client_notes || "No notes available!",
                                              }
                                          }) 
                                        }
                                      }} 
                                      style={{color: row.client_notes? theme.palette.primary.main: "#D5D5D5", cursor: 'pointer'}} />
                                </Tooltip>
                            </Box>
                          </StyledContentTableCell>)}

                          <StyledContentTableCell
                            component="th"
                            scope="row"
                            style={{ backgroundColor: '#f2f9ff', maxWidth: '200px' }}
                          >
                            <Tooltip title={row.url}>
                              {state.content.fullView.currentStatus === 'published' ? (
                                <a href={row.url} target="_blank" rel="noreferrer">
                                  {row.url}
                                </a>
                              ) : (
                                <span>{row.url}</span>
                              )}
                            </Tooltip>
                          </StyledContentTableCell>
                          {state.content.fullView.currentStatus !== 'topics_for_review' &&
                            state.content.fullView.currentStatus !== 'writing'  && state.content.fullView.currentStatus !== 'qa' && (
                              <StyledContentTableCell
                                component="th"
                                scope="row"
                                style={{ backgroundColor: '#f2f9ff', minWidth: 150 }}
                              >
                                {row.google_doc_url ? (
                                  <a
                                    href={`${row.access_google_doc}&email=${state.auth.user.email}${state.auth.user.alternateEmail ? `&email=${state.auth.user.alternateEmail}` : ''}`}
                                    style={{ cursor: 'pointer', color: '#2A5CA9' }}
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    Open Content Page &gt;&gt;
                                  </a>
                                ) : (
                                  <p
                                    style={{
                                      cursor: 'not-allowed',
                                      color: '#2A5CA9',
                                      textDecoration: 'underline',
                                    }}
                                  >
                                    No Content Document
                                  </p>
                                )}
                              </StyledContentTableCell>
                            )}
                          <StyledContentTableCell component="th" scope="row" style={{ backgroundColor: '#f2f9ff' }}>
                            {row.word_count || 'N/A'}
                          </StyledContentTableCell>
                          <StyledContentTableCell
                            component="th"
                            scope="row"
                            style={{ backgroundColor: '#f2f9ff' }}
                          >
                            {row.content_type}
                          </StyledContentTableCell>
                          {(state.content.fullView.currentStatus === 'content_for_review' || state.content.fullView.currentStatus === 'revised_content_for_review') &&
                            state.websiteSwitch.currentWebsiteSettings.assignPageFeature && (
                              <StyledContentTableCell
                                component="th"
                                scope="row"
                                style={{ backgroundColor: '#f2f9ff' }}
                              >
                                <FormControl style={{ width: '100%' }}>
                                  <Select value={row.reviewer ? row.reviewer.email : ''}>
                                    {state.content.fullView.availableReviewers.map((el) => (
                                      <MenuItem
                                        key={el.id}
                                        value={el.email}
                                        onClick={() => setReviewer(el, row.id)}
                                      >
                                        {el.email ? el.email : '<unset>'}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              </StyledContentTableCell>
                            )}
                        </TableRow>
                      ) : (
                        <TableRow key={row.id}>
                          <StyledContentTableCell
                            component="th"
                            scope="row"
                          >
                            {(index + 1) + (state.content.fullView.perPage * (state.content.fullView.currentPage - 1))}
                          </StyledContentTableCell>
                          {(state.content.fullView.currentStatus === 'topics_for_review' ||
                            state.content.fullView.currentStatus === 'content_for_review' ||
                            state.content.fullView.currentStatus === 'writing_external_content' || 
                            state.content.fullView.currentStatus === 'needs_edits_external_content' ||
                            state.content.fullView.currentStatus === 'revised_content_for_review') && (
                            <>
                              <StyledContentTableCell component="th" scope="row">
                                <Checkbox
                                  checked={state.content.fullView.checked[row.id.toString()]}
                                  onChange={handleCheckBox}
                                  name={row.id.toString()}
                                  color="primary"
                                  inputProps={{ 'aria-label': 'checkbox' }}
                                />
                              </StyledContentTableCell>
                            </>
                          )}
                          <StyledContentTableCell component="th" scope="row">
                            {`${new Date(row.date).toLocaleString('en-US', { timeZone: 'UTC', month: 'short', year: 'numeric'})}`}
                          </StyledContentTableCell>
                          <StyledContentTableCell component="th" scope="row">
                            {row.h1}
                          </StyledContentTableCell>

                          {state.content.fullView.currentStatus === 'writing_external_content' && (<StyledContentTableCell>
                            <Box ml='5px' mt='5px'>
                                <Tooltip title={row.client_notes? "See Notes": "No notes available!"} placement='top' style={{ fontSize: '16px'}} arrow>
                                  <InfoIcon 
                                      onClick={() => { 
                                        if(row.client_notes){
                                          dispatch({
                                            type: contentActions.SET_CLIENT_NOTES_OPEN,
                                            payload: { 
                                              clientNotesOpen: true,
                                            }
                                          })
                                          dispatch({
                                              type: contentActions.SET_SELECTED_CLIENT_NOTE,
                                            payload: { 
                                              selectedClientNote: row.client_notes || "No notes available!",
                                            }
                                          }) 
                                        }
                                      }} 
                                      style={{color: row.client_notes? theme.palette.primary.main: "#D5D5D5", cursor: 'pointer'}} />
                                </Tooltip>
                            </Box>
                          </StyledContentTableCell>)}
                          {state.content.fullView.currentStatus === 'needs_edits_external_content' && (<StyledContentTableCell>
                            <Box ml='5px' mt='5px'>
                                <Tooltip title={row.client_notes? "See Notes": "No notes available!"} placement='top' style={{ fontSize: '16px'}} arrow>
                                  <InfoIcon 
                                      onClick={() => { 
                                        if(row.client_notes){
                                          dispatch({
                                            type: contentActions.SET_CLIENT_NOTES_OPEN,
                                            payload: { 
                                              clientNotesOpen: true,
                                            }
                                          })
                                          dispatch({
                                              type: contentActions.SET_SELECTED_CLIENT_NOTE,
                                            payload: { 
                                              selectedClientNote: row.client_notes || "No notes available!",
                                            }
                                          }) 
                                        }
                                      }} 
                                      style={{color: row.client_notes? theme.palette.primary.main: "#D5D5D5", cursor: 'pointer'}} />
                                </Tooltip>
                            </Box>
                          </StyledContentTableCell>)}

                          <StyledContentTableCell component="th" scope="row" style={{ maxWidth: '200px', textOverflow: 'ellipsis', overflow: 'hidden' }}>
                            <Tooltip title={row.url}>
                              {state.content.fullView.currentStatus === 'published' ? (
                                <a href={row.url} target="_blank" rel="noreferrer">
                                  {row.url}
                                </a>
                              ) : (
                                <span>{row.url}</span>
                              )}
                            </Tooltip>
                          </StyledContentTableCell>
                          {state.content.fullView.currentStatus !== 'topics_for_review' &&
                            state.content.fullView.currentStatus !== 'writing' && state.content.fullView.currentStatus !== 'qa' && (
                              <StyledContentTableCell
                                component="th"
                                scope="row"
                                style={{ minWidth: 150 }}
                              >
                                {row.google_doc_url ? (
                                  <a
                                    href={`${row.access_google_doc}&email=${state.auth.user.email}${state.auth.user.alternateEmail ? `&email=${state.auth.user.alternateEmail}` : ''}`}
                                    style={{ cursor: 'pointer', color: '#2A5CA9' }}
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    Open Content Page &gt;&gt;
                                  </a>
                                ) : (
                                  <p
                                    style={{
                                      cursor: 'not-allowed',
                                      color: '#2A5CA9',
                                      textDecoration: 'underline',
                                    }}
                                  >
                                    No Content Document
                                  </p>
                                )}
                              </StyledContentTableCell>
                            )}
                          <StyledContentTableCell component="th" scope="row">
                            {row.word_count || 'N/A'}
                          </StyledContentTableCell>
                          <StyledContentTableCell component="th" scope="row">
                            <Chip label={getProdTypeLabel(row.prod_type)} />
                          </StyledContentTableCell>
                          <StyledContentTableCell component="th" scope="row">
                            {row.content_type}
                          </StyledContentTableCell>
                          {(state.content.fullView.currentStatus === 'content_for_review' || 
                             state.content.fullView.currentStatus === 'revised_content_for_review') &&
                            state.websiteSwitch.currentWebsiteSettings.assignPageFeature && (
                              <StyledContentTableCell component="th" scope="row">
                                <FormControl style={{ width: '100%' }}>
                                  <Select value={row.reviewer ? row.reviewer.email : ''}>
                                    {state.content.fullView.availableReviewers.map((el) => (
                                      <MenuItem
                                        key={el.email}
                                        value={el.email}
                                        onClick={() => setReviewer(el, row.id)}
                                      >
                                        {el.email ? el.email : '<unset>'}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              </StyledContentTableCell>
                            )}

                          {state.content.fullView.currentStatus === 'published' && (
                            <StyledContentTableCell>
                              <span style={{ whiteSpace: 'nowrap' }}>
                                {row.published_date
                                  ? new Date(row.published_date).toLocaleDateString('en-us', {
                                      year: 'numeric',
                                      month: 'short',
                                      day: 'numeric',
                                    })
                                  : '-'}
                              </span>
                            </StyledContentTableCell>
                          )}
                        </TableRow>
                      )
                    )
                  ) : (
                    <TableRow>
                      <StyledContentTableCell>No results</StyledContentTableCell>
                    </TableRow>
                  )}
                </TableBody>
              )}
            </Table>
          </div>
          {isInternalFetching && (
            <div className={classes.loading} style={{ height: tableBodyHeight }}>
              <CircularProgress />
            </div>
          )}
          <Divider />
          <div className={classes.card__wrapper}>
            <div className={classes.cardActionButton} aria-hidden="true">
              {disablePrevNextBtn ? (
                <Box margin="auto">
                  <CircularProgress />
                </Box>
              ) : (
                <StyledTablePagination
                  rowsPerPageOptions={[15, 50]}
                  component="div"
                  count={state.content.fullView.total}
                  rowsPerPage={state.content.fullView.perPage}
                  page={state.content.fullView.currentPage - 1}
                  onPageChange={!disablePrevNextBtn && handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  nextIconButtonProps={{ 'aria-label': 'next page button' }}
                  ActionsComponent={TablePaginationActions}
                />
              )}
            </div>
          </div>
        </div>
        <Grow in={state.content.fullView.areSelected}>
          <div className={classes.popUp} style={{ margin: 'auto' }} aria-label="actions">
            <span className={classes.popUpText}>
              {state.content.fullView.totalChecked} items selected
            </span>
            {state.content.fullView.currentStatus === 'writing_external_content' && (<PurpleButton onClick={() => handleOpenApprovalModal('qa')} aria-label="action-approve">
              <p className={classes.approvalText}>Send to QA</p>
            </PurpleButton>)}
            {state.content.fullView.currentStatus === 'needs_edits_external_content' && (<PurpleButton onClick={() => handleOpenApprovalModal('qa')} aria-label="action-approve">
              <p className={classes.approvalText}>Send to QA</p>
            </PurpleButton>)}
            {state.content.fullView.currentStatus !== 'writing_external_content' && state.content.fullView.currentStatus !== 'needs_edits_external_content' && (<GreenButton onClick={() => handleOpenApprovalModal(true)} aria-label="action-approve">
              <p className={classes.approvalText}>Approve</p>
            </GreenButton>)}
            {state.content.fullView.currentStatus !== 'writing_external_content' && state.content.fullView.currentStatus !== 'needs_edits_external_content' && state.content.fullView.currentStatus !== 'content_for_review' && state.content.fullView.currentStatus !== 'revised_content_for_review' && (<RedButton onClick={() => handleOpenApprovalModal(false)}>
              <p className={classes.approvalText}>Disapprove</p>
            </RedButton>)}
            {(state.content.fullView.currentStatus === 'content_for_review' || state.content.fullView.currentStatus === 'revised_content_for_review') && (
              <GreenButton
                style={{ background: '#dee300' }}
                onClick={() => handleOpenApprovalModal('with comments')}
              >
                <p className={classes.approvalText}>Approve With Comments</p>
              </GreenButton>
            )}
            {(state.content.fullView.currentStatus === 'content_for_review' || state.content.fullView.currentStatus === 'revised_content_for_review') && (
              <GreenButton
                style={{ background: '#FFB946' }}
                onClick={() => handleOpenApprovalModal('revision')}
              >
                <p className={classes.approvalText}>Send for Revisions</p>
              </GreenButton>
            )}
            {(state.content.fullView.currentStatus === 'content_for_review' || state.content.fullView.currentStatus === 'revised_content_for_review') && (<RedButton onClick={() => handleOpenApprovalModal(false)}>
              <p className={classes.approvalText}>Reject</p>
            </RedButton>)}
            {(state.content.fullView.currentStatus === 'content_for_review' || state.content.fullView.currentStatus === 'revised_content_for_review') &&
              state.websiteSwitch.currentWebsiteSettings.assignPageFeature && (
                <>
                  <span style={{ color: 'white', marginLeft: 10 }}>Set Reviewer: </span>
                  <FormControl>
                    <div
                      style={{
                        color: 'white',
                        padding: '0px 10px',
                        margin: 5,
                        borderRadius: 20,
                        background: '#5AA600',
                      }}
                    >
                      <Select
                        value={modalReviewer}
                        className={selectClasses.select}
                        inputProps={{
                          classes: {
                            icon: selectClasses.icon,
                            root: selectClasses.root,
                          },
                        }}
                      >
                        {state.content.fullView.availableReviewers.map((el) => (
                          <MenuItem
                            key={el.id}
                            value={el.email}
                            onClick={() => setReviewerInBulk(el)}
                          >
                            {el.email}
                          </MenuItem>
                        ))}
                      </Select>
                    </div>
                  </FormControl>
                </>
              )}
            <ClearIcon
              style={{ color: 'white', marginLeft: 20, cursor: 'pointer' }}
              onClick={() => handleCheckAll({ target: { checked: false } })}
            />
          </div>
        </Grow>
        <Snackbar
          open={openNotification}
          autoHideDuration={6000}
          onClose={handleNotificationClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          key="bottom left"
        >
          {notificationAction ? (
            <Alert onClose={handleNotificationClose} severity="success">
              Pages approved
            </Alert>
          ) : (
            <Alert onClose={handleNotificationClose} severity="error">
              Pages disapproved
            </Alert>
          )}
        </Snackbar>
        <Snackbar
          open={actionError}
          autoHideDuration={6000}
          onClose={() => {
            setActionError(null)
          }}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          key="bottom left"
        >
          <Alert onClose={() => {setActionError(null)}} severity="error">
            {actionError}
          </Alert>
        </Snackbar>
        <Dialog
          open={openDialog}
          onClose={() => {
            setOpenDialog(false);
          }}
          aria-labelledby="form-dialog-title"
        >
          {(state.content.fullView.selectedAction === 1 ||
            state.content.fullView.selectedAction === 3 ||
            state.content.fullView.selectedAction === 5) && (
            <>
              {state.content.fullView.currentStatus === 'topics_for_review' && (
                <DialogTitle id="form-dialog-title">
                  Are you sure you want to Approve the selected strategies?
                </DialogTitle>
              )}
              {(state.content.fullView.currentStatus === 'content_for_review' || state.content.fullView.currentStatus === 'revised_content_for_review') && (
                <DialogTitle id="form-dialog-title">
                  {state.content.fullView.selectedAction === 1 ? 'Are you sure you want to approve the selected article(s)?' : 'Are you sure you want to approve the selected article(s) with comments?'}
                </DialogTitle>
              )}

              {state.content.fullView.currentStatus === 'topics_for_review' && (
                <DialogContent>
                  Approving these strategies will place them in &ldquo;Writing&rdquo;. Please contact your
                  account manager if you have any questions.
                </DialogContent>
              )}
              {(state.content.fullView.currentStatus === 'content_for_review' || state.content.fullView.currentStatus === 'revised_content_for_review') &&
                state.content.fullView.selectedAction !== 3 && (
                  <DialogContent>
                    Approving these article(s) will send them to our publishing queue as they currently appear in the Google Document. If you have any comments or edits, please select &ldquo;Approve with Comments&rdquo; or &ldquo;Send for Revisions&rdquo;. Please contact your account manager if you have any questions.
                  </DialogContent>
                )}
              {state.content.fullView.selectedAction === 4 && (
                <DialogContent>
                  Approving these articles with comment will place them &ldquo;Send for Revisions&rdquo;.
                  Please contact your account manager if you have any questions.
                </DialogContent>
              )}
              {state.content.fullView.selectedAction === 3 && (
                <DialogContent>
                  Please include a brief note regarding your comments and/or revisions. Once revisions are complete, this content will be will be sent straight to our publishers.
                </DialogContent>
              )}
              {state.content.fullView.selectedAction === 3 && (
                <DefaultInput
                  rows={3}
                  className={classes.approveComment}
                  multiline
                  error={rejectedCommentError}
                  label="Please leave your note here (required)"
                  variant="outlined"
                  value={rejectComment}
                  helperText="Please include a comment longer than 25 characters."
                  data-testid="details_test_id"
                  type="text"
                  onChange={(e) => {
                    ChangeRejectComment(e.target.value);
                  }}
                />
              )}
              {state.content.fullView.selectedAction === 3 && (
                <DialogContent>
                  (If you <strong>want to review the content again</strong> after the revisions have been made, please select &ldquo;Send for Revisions&rdquo;)
                </DialogContent>
              )}
              {state.content.fullView.currentStatus === 'writing_external_content' && (
                <DialogContent>
                  Approving this action will send the articles to our quality assurance stage. Please contact your
                  account manager if you have any questions.
                </DialogContent>
              )}
              {state.content.fullView.currentStatus === 'needs_edits_external_content' && (
                <DialogContent>
                  Approving this action will send the articles to our quality assurance stage. Please contact your
                  account manager if you have any questions.
                </DialogContent>
              )}
              <DialogActions>
                <Button
                  onClick={() => {
                    setOpenDialog(false);
                    setRejectedCommentError(false);
                    ChangeRejectComment('');
                  }}
                  style={{ color: '#58595B' }}
                >
                  Cancel
                </Button>
                <GreenButton aria-label="submit won" onClick={() => handleApproveSelected(true)}>
                  Submit
                </GreenButton>
              </DialogActions>
            </>
          )}
          {(state.content.fullView.selectedAction === 2  || 
            state.content.fullView.selectedAction === 4) && (
            <>
              {state.content.fullView.currentStatus === 'topics_for_review' && (
                <DialogTitle id="form-dialog-title">
                  Are you sure you want to reject the selected article topic?
                </DialogTitle>
              )}
              {(state.content.fullView.currentStatus === 'content_for_review' || state.content.fullView.currentStatus === 'revised_content_for_review') && (
                <DialogTitle id="form-dialog-title">
                  {state.content.fullView.selectedAction === 2 ? 'Are you sure you want to reject the selected article(s)?' : 'Are you sure you want to send the selected article(s) back for revisions?'}
                </DialogTitle>
              )}
              {state.content.fullView.currentStatus === 'topics_for_review' && (
                <DialogContent>
                  Rejecting the article topic will place it back into ideation and planning where we will develop new topic(s). Please be sure to add your reasons for rejection to the comments section below so we can deliver improved topics.
                </DialogContent>
              )}
              {(state.content.fullView.currentStatus === 'content_for_review' || state.content.fullView.currentStatus === 'revised_content_for_review') && (
                <DialogContent>
                  {state.content.fullView.selectedAction === 2 ? 'Please include a brief note on why this content is being rejected. ' : 'Please include a brief note regarding your revisions. Once revisions are complete, this content will be sent back to you for review. '}
                </DialogContent>
              )}
              {(state.content.fullView.currentStatus === 'topics_for_review' || state.content.fullView.currentStatus === 'content_for_review' || state.content.fullView.currentStatus === 'revised_content_for_review') && (
                <DefaultInput
                  rows={3}
                  className={classes.rejectComment}
                  multiline
                  error={rejectedCommentError}
                  label="Please leave your note here (required)"
                  variant="outlined"
                  value={rejectComment}
                  data-testid="details_test_id"
                  helperText="Please include a comment longer than 25 characters."
                  type="text"
                  onChange={(e) => {
                    ChangeRejectComment(e.target.value);
                  }}
                />
              )}
              {(state.content.fullView.currentStatus === 'content_for_review' || state.content.fullView.currentStatus === 'revised_content_for_review') && (
                <DialogContent>
                  {state.content.fullView.selectedAction === 2 ? <>(Rejecting this page will remove it from the production queue, but as the topic was approved, it will still count toward your monthly total. If you <strong>want us to revise the topic or article content</strong>, please select &ldquo;Send for Revisions&rdquo;).</> : <>(If you <strong>do not want to to review the content again</strong> after the revisions have been made, please select &ldquo;Approve with Comments&rdquo;)</>}
                </DialogContent>
              )}
              <DialogActions>
                <Button
                  onClick={() => {
                    setOpenDialog(false);
                    setRejectedCommentError(false);
                    ChangeRejectComment('');
                  }}
                  style={{ color: '#58595B' }}
                >
                  Cancel
                </Button>
                <RedButton aria-label="submit lost" onClick={() => handleApproveSelected(false)}>
                  Submit
                </RedButton>
              </DialogActions>
            </>
          )}
        </Dialog>
        <Dialog
          open={openStrategyDialog}
          className={classes.dialogContent}
        >
          <DialogTitle id="form-dialog-title" className={classes.mainTitle}>
            <Box width='100%' marginBottom='10px'>
              {availableYears.length > 0 && <Select
                value={currYear}
              >
                {availableYears.map((el) => (
                  <MenuItem
                    key={el}
                    value={el}
                    onClick={() => setCurrYear(el)}
                  >
                    {el}
                  </MenuItem>
                ))}
              </Select>}
            </Box>
            Behind the Strategy
          </DialogTitle>
          <DialogContent style={{
            height: '400px',
          }}>
            {availableYears.length > 0 && typeof currContentStrategy === 'string' && parse(currContentStrategy)}
            {availableYears.length === 0 && <Box textAlign='center' my={3}>
              No Content Strategies available yet for <strong style={{color: theme.palette.primary.main}}>{state.websiteSwitch.currentWebsite}</strong>
            </Box>}
          </DialogContent>
          <DialogActions>
            <Box margin='auto' display='flex' flexDirection='row' flexGap={3}>            
              <Box 
                onClick={availableQuarters && availableQuarters.filter(item => parseInt(item, 10) === 1).length > 0 ? () => setCurrQuarter(1) : null} 
                color={currQuarter === 1 ? 'white' : 'inherit' }
                borderColor={currQuarter === 1 ? theme.palette.primary.main : 'inherit' } 
                border='1px solid' 
                disabled={availableQuarters && availableQuarters.filter(item => parseInt(item, 10) === 1).length > 0}
                padding='10px' 
                cursor='pointer' 
                borderRadius='4px' 
                m={1}
                style={{
                  background: currQuarter === 1 ? theme.palette.primary.main : 'inherit',
                  cursor: 'pointer',
                  opacity: availableQuarters && availableQuarters.filter(item => parseInt(item, 10) === 1).length > 0 ? '1' : '.3'
                }}
              >
                Q1
              </Box>
              <Box 
                onClick={availableQuarters && availableQuarters.filter(item => parseInt(item, 10) === 2).length > 0 ? () => setCurrQuarter(2) : null} 
                color={currQuarter === 2 ? 'white' : 'inherit' }
                borderColor={currQuarter === 2 ? theme.palette.primary.main : 'inherit' } 
                border='1px solid' 
                disabled={availableQuarters && availableQuarters.filter(item => parseInt(item, 10) === 2).length > 0}
                padding='10px' 
                cursor='pointer' 
                borderRadius='4px' 
                m={1}
                style={{
                  background: currQuarter === 2 ? theme.palette.primary.main : 'inherit',
                  cursor: 'pointer',
                  opacity: availableQuarters && availableQuarters.filter(item => parseInt(item, 10) === 2).length > 0 ? '1' : '.3'
                }}
              >
                Q2
              </Box>
              <Box 
                onClick={availableQuarters && availableQuarters.filter(item => parseInt(item, 10) === 3).length > 0 ? () => setCurrQuarter(3) : null} 
                color={currQuarter === 3 ? 'white' : 'inherit' }
                borderColor={currQuarter === 3 ? theme.palette.primary.main : 'inherit' } 
                border='1px solid'
                disabled={availableQuarters && availableQuarters.filter(item => parseInt(item, 10) === 3).length > 0}
                padding='10px' 
                cursor='pointer' 
                borderRadius='4px' 
                m={1}
                style={{
                  background: currQuarter === 3 ? theme.palette.primary.main : 'inherit',
                  cursor: 'pointer',
                  opacity: availableQuarters && availableQuarters.filter(item => parseInt(item, 10) === 3).length > 0 ? '1' : '.3'
                }}
              >
                Q3
              </Box>
              <Box 
                onClick={availableQuarters && availableQuarters.filter(item => parseInt(item, 10) === 4).length > 0 ? () => setCurrQuarter(4) : null}
                color={currQuarter === 4 ? 'white' : 'inherit' } 
                borderColor={currQuarter === 4 ? theme.palette.primary.main : 'inherit' }
                disabled={availableQuarters &&  availableQuarters.filter(item => parseInt(item, 10) === 4).length > 0}
                border='1px solid' 
                padding='10px' 
                cursor='pointer' 
                borderRadius='4px' 
                m={1}
                style={{
                  background: currQuarter === 4 ? theme.palette.primary.main : 'inherit',
                  cursor: 'pointer',
                  opacity: availableQuarters && availableQuarters.filter(item => parseInt(item, 10) === 4).length > 0 ? '1' : '.3'
                }}
              >
                Q4
              </Box>
            </Box>
            <Button
              onClick={() => {
                setOpenStrategyDialog(false);
              }}
              style={{ 
                color: '#58595B',
                position: 'absolute',
                bottom: '15px',
                right: isPhone ? '0' : '10px',
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
        {state.content.clientNotesOpen && (<ClientNotesDialogContent />)}
      </div>
    </>
  );
};

export default ContentFullView;
